<template>
  <AppHeader title="Return Invoices" />
<div>
    <div  class="container-fluid">

    <div class="container-fluid">
        <div>          
          <button class="add" @click="handleProcessReturn()">Create return invoice</button>
          <!--<button class="add" @click="printOrder()">Print</button>                      -->
        </div>
          <br>
        <div class="orders-container">
          <div class="order-row" v-for="item in orders" :key="item.orderId">

            <span class="order-id"><b>{{ jsonData.order_no }}:</b> {{ item.orderId }}</span>
            <span class="order-id"><b>Items:</b> {{ item.ItemsCount }}</span>
            <span class="order-id"><b>Total price:</b> {{ item.totalPrice }}</span>
            <span class="order-id"><b>User:</b> {{ item.userName }}</span>
            <span class="order-id"><b>Order Date:</b> {{ item.orderDate }}</span>

          </div>
        </div>

        <div style="padding-top:10px;height: 300px;overflow:auto; vertical-align: top;">
          <table class="table"  style="color: #fff;margin-top: 0px;padding-top:0px">
            <thead>
              <tr>
                <th class="col-sm-3" style="text-align:right;font-size: 19px;text-align:center">Item name</th>
                <th class="col-sm-3" style="text-align:right;font-size: 19px;">Qty</th>
                <th class="col-sm-3" style="text-align:right;font-size: 19px;width:50px">Return qty</th>
                <th class="col-sm-3" style="text-align:right;font-size: 19px;width:50px">Rate</th>
                <th class="col-sm-3" style="text-align:right;font-size: 19px;">Price</th>  
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in retOrderItems" :key="item.seqId">
                <td class="grid-child-element purple" style="text-align:right;font-size: 19px;text-align: left;"><a href="#" @click="deleteOrderItem(item.seqId)" style="color:red"><span class="glyphicon glyphicon-minus"></span></a>{{item.item_name}}</td>
                <td class="grid-child-element green" style="text-align:right;font-size: 19px;width:50px">{{parseFloat(item.qty).toFixed(3)}}</td>
                <td class="grid-child-element green" style="text-align:right;font-size: 19px;width:50px">{{parseFloat(item.qty_return).toFixed(3)}}</td>
                <td class="grid-child-element green" style="text-align:right;font-size: 19px;width:50px">{{(parseFloat(item.standard_rate)).toFixed(2)}}</td>
                <td class="grid-child-element green" style="text-align:right;font-size: 19px;">{{(parseFloat(item.price)).toFixed(2)}}</td>
              </tr>
            </tbody>
              
          </table>
          
        </div>

    </div> 
    <div>
      <div v-if="toggle">  
          <!-- <table class="table"  style="color: #fff;margin-top: 0px;margin-bottom: 0px;">
              <tr>
                <td>
                  <div class="grid-container-element" style="font-size: 21px;">
                      <div class="grid-child-element purple" style="text-align:right">{{this.item_name}}</div>
                      <div class="grid-child-element green" style="text-align:right">{{this.qty}}</div>
                      <div class="grid-child-element green" style="text-align:right">{{this.unit_price}}</div>
                      <div class="grid-child-element green" style="text-align:right">{{this.item_price}}</div>
                      <div class="grid-child-element green"></div>
                  </div>
                </td>
              </tr>
          </table>

          <table class="table"  style="color: #fff;margin-top: 0px;padding-top:0px">
              <tr v-for="item in orderItems" :key="item.seqId">
                <td>
                    <div class="grid-container-element" style="padding-bottom:4px;padding-top:4px">
                        <div class="grid-child-element purple" style="text-align:right;font-size: 19px;">{{item.item_name}}</div>
                        <div class="grid-child-element green" style="text-align:right;font-size: 19px;">{{parseFloat(item.qty).toFixed(3)}}</div>
                        <div class="grid-child-element green" style="text-align:right;font-size: 19px;">{{(parseFloat(item.standard_rate)).toFixed(2)}}</div>
                        <div class="grid-child-element green" style="text-align:right;font-size: 19px;">{{(parseFloat(item.price)).toFixed(2)}}</div>
                        <div class="grid-child-element green" style="text-align:right;font-size: 19px;"><a href="#" @click="deleteOrderItem(item.seqId)" style="color:red"><span class="glyphicon glyphicon-minus"></span></a></div>
                    </div>
                </td>
              </tr>
          </table> -->
      </div>
      <div class="row" style="padding: 15px; margin-top: 10px;">
         <div class="col-sm-4" style="width:100%;color:#000000; background-color: #1a1f2f; min-height: 210px;">
            <div class="col-sm-4" style="position:fixed;width:250px;height:30px; min-height: 20px;left:0px;bottom:230px;margin-top: 0px;margin-bottom: 0px;margin-left : 0px;color:#000000; background-color: #1a1f2f;margin-left: -15px;margin-right: -10px;">
              <a href="#" v-show="!setQty" @click="changCurrentItemQty()" style="color:green;"><span class="glyphicon glyphicon-ok" style="padding-bottom:20px;margin-left:80px"></span></a>
            </div>
            <div class="col-sm-4" style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-top: 0px;margin-bottom: 0px;margin-left : 0px;color:#000000; background-color: #1a1f2f;margin-left: -15px;margin-right: -10px;">
              <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="showKeypad"/>
            </div>
         </div>
         <div class="col-sm-4" style="color:#ffffff;position:fixed;left:440px;bottom:40px;margin-bottom: -50px;margin-left : 0px;width:205px;height:230px;">
          <div class="row" style="background-color: var(--color4);margin-bottom: 0px; border-style: outset; height: 210px;border-radius: 10px;">
            <p style="font-size: 16px; font-weight: 700; text-align: center; color: #000000;margin: 0px 0px;">{{this.jsonData.payment_method}}</p>
            <div class="row" style="margin: 0px; padding: 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;"> <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1.1em;">{{this.jsonData.gift_card}}:</p></div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;"> <p style="font-weight: 700; color:black; font-size:1.2em ">{{(formatNumber(this.balance))}}</p></div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;"> <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1.1em;">{{this.jsonData.cash}}:</p></div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px; "> <p style="font-weight: 700; color:black; font-size:1.2em;">{{(formatNumber(this.orderCashAmount))}}</p></div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;"> <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1.1em;">{{this.jsonData.credit}}:</p></div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;"> <p style="font-weight: 700; color:black; font-size:1.2em;">{{(formatNumber(this.orderCreditAmount))}}</p></div>
            </div>
             <div class="row" style="margin: 0px; padding: 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;"> <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1.1em;">{{this.jsonData.mobile_btn}}:</p></div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;"> <p style="font-weight: 700; color:black; font-size:1.2em;">{{(formatNumber(this.orderMobileAmount))}}</p></div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:200px">
              <!--<div class="col-sm-6" style="text-align: left; color: #000000;"> <p style="font-size: 14px; font-weight: 700; padding-left: 15px;">Account:</p></div>-->
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;"> <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1.1em;">{{this.jsonData.account}}:</p></div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;"> <p style="font-weight: 700; color:black; font-size:1.2em;">{{(formatNumber(this.orderAccountAmount))}}</p></div>
            </div>
          </div>
         </div>

         <div class="col-sm-4" style="color:#ffffff;position:fixed;left:640px;bottom:-10px;margin-bottom: 0px;margin-left : 0px;width:250px;height:230px;">
           <div v-show="showloyality" style="background-color: #CCCCCC;margin-top:0px;margin-bottom:0px;border-top: 1px solid #CCCCCC; border-right: 1px solid #333333; border-bottom: 1px solid #333333; border-left: 1px solid #CCCCCC;padding-top:5px;padding-left:10px;border-radius: 10px;">
             <h2 style="font-size: 16px;color:navy;font-weight: bold;margin-bottom:20px;text-align:center">{{this.jsonData.loyalty_customer_info}}</h2>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:12px">{{this.jsonData.loyalty_name}}: {{this.name}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:12px">{{this.jsonData.loyalty_gender}}: {{this.gender}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:12px">{{this.jsonData.loyalty_email}}: {{this.email}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:12px">{{this.jsonData.loyalty_phone}}: {{this.phone }}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:12px">{{this.jsonData.loyalty_total_points}}: {{this.totalpoints}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.loyalty_customer_since}}: {{this.customersince}}</h3>
           </div>
           <!--          <div v-show="giftCardInfos" style="background-color: #FFFFFF;margin-top:10px;margin-bottom:10px;border-top: 1px solid #CCCCCC; border-right: 1px solid #333333; border-bottom: 1px solid #333333; border-left: 1px solid #CCCCCC;padding-top:5px;padding-left:10px">
             <h2 style="font-size: 16px; font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_info}}:</h2>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_number}}: {{this.giftcardnumber}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_name}}: {{this.giftcardname}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_balance}}: {{this.balance}}</h3>
           </div>
            -->
 
         </div> 
         
         <div class="col-sm-4" style="padding-top:3px;background-color:#1a1f2f;color:#ffffff;position:fixed;left:220px;bottom:-7px;margin-left : 0px;width:210px;height:230px;font-size:1.2em">
          <div class="row" style="margin-bottom: 40px; border-style: outset;height: 210px;border-radius: 10px;">
          <div class="row" style="margin: 0px; width:210px;padding-top:0px;">
            <div class="col-sm-9" style="text-align: left; color: #ffffff;"> <p style=" font-weight: 300; color:white; font-size:1.1em"><b>Items# :</b></p></div>
            <div class="col-sm-3" style="text-align: right; color: #ffffff;"> <p style=" font-weight: 300; color:white; font-size:1.1em">{{this.orderItems.length+this.currentItem.length}}</p></div>
          </div>          
          <div class="row" style="margin: 0px; width:210px;padding-top:10px;">
            <div class="col-sm-7" style="text-align: left; color: #ffffff;"> <p style=" font-weight: 300;  color:white; font-size:1.1em">{{this.jsonData.net_total}}:</p></div>
            <div class="col-sm-5" style="text-align: right; color: #ffffff;"> <p style=" font-weight: 300; color:white; font-size:1.1em">{{(formatNumber(this.netTotalAmount))}}</p></div>
          </div>
          <div class="row" style="margin: 0px; padding: 0px;width:210px">
            <div class="col-sm-7" style="text-align: left; color: #ffffff;"> <p style=" font-weight: 300;  color:white; font-size:1.1em">Vat:</p></div>
            <div class="col-sm-5" style="text-align: right; color: #ffffff;"> <p style=" font-weight: 300; color:white; font-size:1.1em">{{formatNumber(this.vatAmount)}}</p></div>
          </div>
          <div class="row" style="margin: 0px; padding: 0px;width:210px">
            <div class="col-sm-7" style="text-align: left; color: #ffffff;"> <p style=" font-weight: 300;  color:white; font-size:1.1em">{{this.jsonData.discount}}:</p></div>
            <div class="col-sm-5" style="text-align: right; color: #ffffff;"> <p style=" font-weight: 300; color:white; font-size:1.1em">{{(formatNumber(this.discountAmount))}}</p></div>
          </div>
          <div class="row" style="margin: 0px; padding: 0px; width:210px;">
            <div class="col-sm-7" style="text-align: left; color: #ffffff;"> <p style="font-weight: 300;  color:white; font-size:1.1em">Grand:</p></div>
            <div class="col-sm-5" style="text-align: right; color: #ffffff;"> <p style=" font-weight: 300; color:white; font-size:1.1em">{{(formatNumber(this.grandTotalAmount))}}</p></div>
          </div>
         </div>
      </div>
      </div>
   
     </div>  
     <ReturnReason :open="isReasonOpen" @getReason="setReason($event)" @close="isReasonOpen = !isReasonOpen"/> 
    <Void :open="isVoidOpen" @getVoidUserId="setVoidUserId($event)" @getVoidPermission="setVoidPermission($event)" @close="isVoidOpen = !isVoidOpen"/>
    <ShowInfos :open="isShowInfosOpen" :popupMessage="popupMessage" :msgItems="msgItems" @close="isShowInfosOpen = !isShowInfosOpen"/>
  </div>
</div>
</template>

<script>
  //import ProductList from "@/components/ProductList";
  //import Login from "@/components/Login";
  import Loiality from "@/components/Loiality";
  import GiftCard from "@/components/GiftCard";
  import Void from "@/components/Void";
  import AppHeader from "@/components/AppHeader";
  import ReturnReason from "@/components/ReturnReason";
  import CheckPrice from "@/components/CheckPrice";
  import NewProduct from "@/components/NewProduct";
  
  import PayCash from "@/components/PayCash";
  import PayCredit from "@/components/PayCredit";
  import PayAccount from "@/components/PayAccount";
  import CloseCash from "@/components/CloseCash";
  import ShowInfos from "@/components/ShowInfos";

  import numericpad from "@/components/SimpleKeyboard";
  import { ref } from "vue"
  import axios from "axios";
  import router from '@/router';
  import commonServices from "@/shared/commonServices";
  import MainMenu from "@/components/MainMenu";
  const Swal = require('sweetalert2');
import { mapGetters } from 'vuex';
export default {

  computed: {
    ...mapGetters({
      posData: 'posData',
    })
  },
    mixins: [commonServices],
    mounted() {
      if(localStorage.return_order!==undefined && localStorage.return_order!==null){
        this.showReturnOrder(localStorage.return_order); 
        this.calcOrderTotalAmount();
        this.accountAmount = this.grandTotalAmount;
      }
      if(localStorage.reports_ok === "1"){
        this.reports_ok = true;
      }
      this.getTaxAmount();
      if(localStorage.userId===undefined){
        this.$router.push({ name: 'login'});
      }
      const ScreenSizeDetector = require('screen-size-detector');
      const screen = new ScreenSizeDetector(); // Default options
      if(screen.width == 1024){
        this.screenRes = true;
      }
        //this.$refs.searchProduct.focus();
        this.language = 'ar';
        this.handleLanguage();
        //this.$el.querySelector('#Barcode').focus = true;
        this.getHeaderFooter();

        this.getLogo();
        this.logoImage = '<img src="'+this.logoUrl+'" width="70" height="50" alt="Logo">';
        //this.$refs.input.$el.focus();
        //window.alert(this.$refs.input);
    },    
    beforeCreate () {
        document.querySelector('body').setAttribute('style', 'font-family: "Catamaran", sans-serif;background-color: #1a1f2f;')
    },    
    
    components:{  ReturnReason, Loiality, GiftCard, Void, CheckPrice, PayCash, PayCredit, numericpad, PayAccount, CloseCash, ShowInfos, NewProduct, MainMenu ,AppHeader},
    data: function(){
        return {
          reason: '',
          orders: [],
          payments: [],
          popupMessage: '',
          msgItems: [],
          screenRes: false,
          currencyValues: [],
          showError: false,
          logoImage: '',
          mainErrorMsg: '',
          customerId:0,
          accCustomerid:0,
          taxBaseAmount: 1.18,
          logoUrl:'',
          changeAmount: 0,
          currentOrderId: '',
          currentOrderDirty: false,
          languageName: '',
          item_name:'',
          item_price:'',
          unit_price:'',
          emptyAmount:'',
          pay_cash_title: '',
          pay_cash_cash_amount: '',
          pay_cash_add_payment: '',
          pay_cash_close: '',
          
          qty:'',
          orderHeader: {},
          paymentMethod: {},
          number: "",
          maxLength: 20,
          showKeypad: true,
          jsonData: {},
            language: 'en',
            filterdProducts:[],
            orderItems:[],
            retOrderItems:[],
            promotions:[],
            currentItem:[],
            displayItems:[],
            barcode: '' ,
            seqId : 0,
            products:[],
            toggle: true,
            editedPrice:0,
            editedRoderItem:[],
            authorizedToChangePrice: '',
            totalOrderAmount: 0,
            grandTotalAmount: 0,
            netTotalAmount: 0,
            diffAmount: 0,
            vatAmount:0,   
            notPaidAmount: 0,
            outstandingAmount: '',
            discountAmount: 0,
            paidAmount: 0,
            giftCardAmount: 0,
            prcision: 0,
            ordeCompleted: 'N',
            orderId: '',
             //title:'Loyality',
            lastinvoicenumber: '',
            loyality: null,
            giftCardInfos: null,
            cashAmount: 0,
            creditAmount: 0,
            accountAmount: 0,
            customernumber: '',
            orderCashAmount: 0,
            orderCreditAmount: 0,
            orderMobileAmount: 0,
            orderAccountAmount: 0,
            name: '',
            gender: '',
            email: '',
            phone: '',
            line1: '',
            line2: '',
            area: '',
            city: '',
            
            totalpoints: '',
            dis_percentage: 0,
            prompMinimum_total: 0,
            promoDiscount: 0,
            customersince: '',
            balance: 0,
            giftcardname: '',
            giftcardnumber: 0,
            cashPop: false,
            setQty: true,
            setPrice: true,
            currentItemQty: '',
            currentItemPrice: '',
            setQuantity: false,
            setCurrentPrice: false,
            parked: [],
            parkedSize: 0,
            discountRequested: [],
            delivery: [],
            discountRequestedSize: 0,
            discountRequestedSizeR: 0,
            deliverySize: 0,
            showDiscountRequested: false,
            showParked: false,
            showloyality: false,
            showChange: false,
            showDelivery: false,
            elem: '',
            customername:'',
            deleteItemIndex:-1,
            invoiceHeader: '',
            invoiceFooter: '',
        }
    },
    //props:{
    //  totalOrderAmount : {type: Number},
    //},    
    methods:{
      getUnhandledOrders(){
        this.handleParked();
        this.toggle = false;
        this.showParked = false;
        this.showDiscountRequested = false;
      },
     printElem: function(elem)
			{
				var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none, ');

				mywindow.document.write('<html><head><title>' + document.title  + '</title><style>@page { size:auto; margin: 10px; }</style>');
				mywindow.document.write('</head><body onload="window.print(); window.close();" >');
				//mywindow.document.write('<h1>' + document.title  + '</h1>');
				mywindow.document.write(elem);
        mywindow.document.write('<br><br><br><br>');
				mywindow.document.write('</body></html>');
        mywindow.document.write('x1Fx1Bx1FxFFx49');
        mywindow.document.close(); // necessary for IE >= 10
				mywindow.focus(); // necessary for IE >= 10*/
    //"\x1b\x40",
    //"\x1b\x74\x49", // ESC t 73 - switch to Windows-1251
    //text + "\r\n",
    //"\x1B\x74\x48", // ESC t 72 - switch to Windows-1250
    //text + "\r\n",

				mywindow.print();
				mywindow.close();

				return true;
			},
    showReturnOrder: async function(id){
      try{
          let dataURL = this.apiURL+'Orders/getOrder';
          let orderJson = {"appId": localStorage.appId, 'orderId': id};
          let response = await axios.post(dataURL, orderJson);  
          this.discountAmount = response.data.results.disValue;
          if(response.data.status === 'success'){
            let orderHeader={};
            orderHeader.orderId = response.data.results.invoice;
            orderHeader.ItemsCount = response.data.results.ItemsCount;
            orderHeader.totalPrice = response.data.results.totalPrice;
            orderHeader.userId = response.data.results.userId;
            orderHeader.userName = response.data.results.userName;
            orderHeader.orderDate = response.data.results.orderDate;
            orderHeader.customerId = response.data.results.customerId;
            this.accCustomerid = response.data.results.customerId;
            this.payments = response.data.results.payments;
            if(response.data.results.payments !== null){
              if(this.payments  && this.payments.length >0){
                for( var i = 0; i < this.payments.length; i++){ 
                  if(this.payments[i].paymentType == "cash"){
                    this.orderCashAmount = this.payments[i].amount;
                  }
                  if(this.payments[i].paymentType == "credit"){
                    this.orderCreditAmount = this.payments[i].amount;
                  }
                  if(this.payments[i].paymentType == "mobile"){
                    this.orderMobileAmount = this.payments[i].amount;
                  }
                  
                  if(this.payments[i].paymentType == "account"){
                    this.orderAccountAmount = this.payments[i].amount;
                    this.customerId = this.payments[i].accountId;                
                  }
                }

              }
            }

            this.orders.push(orderHeader);

              for( var i = 0; i < response.data.results.items.length; i++){ 
                let item = {};
                item.seqId = i;
                item.barcode = response.data.results.items[i].barcode;
                item.item_code = response.data.results.items[i].item_code;
                item.item_name = response.data.results.items[i].item_name;
                item.qty = response.data.results.items[i].qty;
                item.qty_return = response.data.results.items[i].qty_return;
                item.standard_rate = response.data.results.items[i].standard_rate;
                item.price = response.data.results.items[i].price;
                item.tax = response.data.results.items[i].tax;
                this.retOrderItems.push(item)
              }
            
              this.customerId = response.data.results.customerId;                
                if(this.customerId!=0){                  
                  this.getCustomerById(this.customerId);
                }else{
                  this.getCustomerById(localStorage.customerId);
                }
          }
      }
      catch (error){
          console.log(error);
      }
    },   
    getCustomerById: async function(customerId){
        try{

            let dataURL = this.apiURL+'Loyalty/getCustomerById';
            let loialityJson = {"appId":localStorage.appId, 'customerId': customerId};
            let response = await axios.post(dataURL, loialityJson); 
            this.loiality = response.data.results[0];
            this.customer_name  = response.data.results[0].name;
            this.name = response.data.results[0].name;
            this.email = response.data.results[0].email;
            this.phone = response.data.results[0].phone;
            this.city = response.data.results[0].city;
            this.area = response.data.results[0].area;
            this.line1 = response.data.results[0].line1;
            this.line2 = response.data.results[0].line2;
            this.totalpoints = response.data.results[0].totalpoints;
            this.customerId = response.data.results[0].id;
            this.giftCardInfos = null;
            this.showloyality = true;
        }
        catch (error){
            console.log(error);
        }
    },

    createReturnOrder: async function(status){
      const nowDate = new Date();
      let orderDetailItems = [];
      let newOrderId = -1;
      try{
          if(this.orderItems.length>0){
            this.orderItems.forEach(function(order) {
              orderDetailItems.push({"item_code":order.item_code,"item_name":order.item_name,"qty":order.qty,"standard_rate":parseFloat(order.standard_rate).toFixed(2),"price":parseFloat(order.price).toFixed(2)});
            });        
          }
          if(this.currentItem.length>0){
            this.currentItem.forEach(function(order) {
              orderDetailItems.push({"item_code":order.item_code,"item_name":order.item_name,"qty":order.qty,"standard_rate":parseFloat(order.standard_rate).toFixed(2),"price":parseFloat(order.price).toFixed(2)});
            });        
          }

          let orderDateTime = '2022-04-23 15:59:22';
          orderDateTime = this.getCurrentDateTime();
          this.orderHeader.appId = localStorage.appId;
          this.orderHeader.userId = localStorage.userId;
          this.orderHeader.orderId = "-1";
          this.orderHeader.original_invoice =this.orders[0].invoice;
          
          this.orderHeader.orderDate = orderDateTime;
          this.orderHeader.discount = this.discountAmount;
          this.orderHeader.totalamount = parseFloat(this.grandTotalAmount).toFixed(2);
          this.orderHeader.customerId = this.customerId;
          this.orderHeader.status = status;
          this.orderHeader.customer_name = this.name;          
          this.orderHeader.orderDetail = orderDetailItems;
          let orderJason = JSON.stringify(this.orderHeader);
          let itIsOk = true;
          if(itIsOk){
              let dataURL = this.apiURL+'Orders/createOrder';
              let response = await axios.post(dataURL, orderJason); 
              if(response.data.status === 'success'){
                this.clearOrderState();
              }            
          }
      }
      catch (error){
          console.log(error);
      }
    },


      getHeaderFooter: async function(){
          try{            
              let dataURL = this.apiURL+'Orders/getInvoiceHeader';
              let logoJson = {"branchId": "1", "langId": "16"};
              let response = await axios.post(dataURL, logoJson); 
              if(response.data.status === 'success'){
                this.invoiceHeader = response.data.results.header;
                this.invoiceFooter = response.data.results.footer;
              }
          }
          catch (error){
              console.log(error);
          }
      },    

     printElemm : function(elem)
			{
        //this.getLogo()
			    var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none');
			    mywindow.document.write('<html><head><title> Invoice </title><style>* {font-size: 12px;font-family: "Times New Romantd, th, tr, table { border-top: 1px solid black; border-collapse: collapse; } "; } td.description, th.description { width: 75px; max-width: 75px; } td.quantity, th.quantity { width: 40px; max-width: 40px; word-break: break-all; } td.price, th.price { width: 40px; max-width: 40px; word-break: break-all; } .centered { text-align: center; align-content: center; } .ticket { width: 155px; max-width: 155px; }</style>');
			    mywindow.document.write('</head><body>');
          //mywindow.document.write('<img src="'+this.logoUrl+'" alt="Logo" width="100%"></img>');
			    //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+'<img src='+this.logoUrl+' width="100%" alt="Logo">'+'</td></tr></table>'; 

          //mywindow.document.write('<h1>' + document.title  + '</h1>');
          //newEle = newEle + this.invoiceHeader+elem+this.invoiceFooter;
          //newEle = newEle + elem;
			    mywindow.document.write(elem);
			    //mywindow.document.write('</body></html>');
			    mywindow.document.write('</body></html>');

			    //mywindow.document.close(); // necessary for IE >= 10
			    //mywindow.focus(); // necessary for IE >= 10*/
          //const myTimeout = setTimeout("", 1000); 
			    mywindow.print();
			    mywindow.close();

			    return true;
			}, 

    showDiscountRequestedOrders: async function(id){
        //console.log("this.orderItems length", this.orderItems.length);
        if(this.currentOrderDirty){
          this.showError= true;
          this.mainErrorMsg = "Please complete last order before start handling new one";
        }else{
          try{
              this.showError= false;
              this.mainErrorMsg = "";
              
              let dataURL = this.apiURL+'Orders/getOrder';
              let orderJson = {"appId": localStorage.appId, 'orderId': id};
              let response = await axios.post(dataURL, orderJson);  
              this.discountAmount = response.data.results.disValue;
              if(response.data.status === 'success'){
                this.orderItems = response.data.results.items;
                this.currentOrderId = response.data.results.invoice;
                this.discountAmount = parseFloat(response.data.results.disValue);
                this.customerId = response.data.results.customerId;                
                if(this.customerId!='' && this.customerId != '0'){                  
                  this.checkLoialityBack(this.customerId);
                }
                this.showDiscountRequested = false;
                this.toggle = true;
                this.calcOrderTotalAmount();  
              }
          }
          catch (error){
              console.log(error);
          }

        }
    },   
    showDeliverydOrders: async function(id){
        if(this.currentOrderDirty){
          this.showError= true;
          this.mainErrorMsg = this.jsonData.complete_current_order;
        }else{
          try{            
              this.showError= false;
              this.mainErrorMsg = "";
              let dataURL = this.apiURL+'Orders/getOrder';
              let orderJson = {"appId": localStorage.appId, 'orderId': id};
              let response = await axios.post(dataURL, orderJson);  
              if(response.data.status === 'success'){

                this.orderItems = response.data.results.items;
                this.currentOrderId = response.data.results.invoice;
                this.customerId = response.data.results.customerId;
                if(this.customerId!='' && this.customerId != '0'){                  
                  this.checkLoialityBack(this.customerId);
                }
                this.showParked = false;
                this.toggle = true;
                this.showDelivery = false;
                this.calcOrderTotalAmount();
              }
          }
          catch (error){
              console.log(error);
          }
        }
    },   
    checkLoialityBack: async function(phone){
        try{

            //Loyality API
            let dataURL = this.apiURL+'Loyalty/checkLoyalty';
            let loialityJson = {"appId":localStorage.appId, 'cardnumber': phone};
            let response = await axios.post(dataURL, loialityJson); 
            this.loiality = response.data;
            
            this.setLoialityPoints(this.loiality);
        }
        catch (error){
            console.log(error);
        }
    },

    showParkedOrders: async function(id){
        if(this.currentOrderDirty){
          this.showError= true;
          this.mainErrorMsg = this.jsonData.complete_current_order;
        }else{
          try{            
              this.showError= false;
              this.mainErrorMsg = "";
              let dataURL = this.apiURL+'Orders/getOrder';
              let orderJson = {"appId": localStorage.appId, 'orderId': id};
              let response = await axios.post(dataURL, orderJson);  
              if(response.data.status === 'success'){
                this.orderItems = response.data.results.items;
                this.currentOrderId = response.data.results.invoice;
                this.customerId = response.data.results.customerId;
                this.customer_name = response.data.results.customer_name;
                if(this.customerId!=='' && this.customerId !== '0'){                  
                  this.checkLoialityBack(this.customerId);
                }else{
                  this.checkLoialityBack(localStorage.customernumber);
                }
                this.showParked = false;
                this.toggle = true;
                this.calcOrderTotalAmount();
              } 
          }
          catch (error){
              console.log(error);
          }
        }
    },   
    deleteOrderItem(id) {
      let tempArr = [];
      let rQty = -1;
      tempArr = this.orderItems.filter(function(a){
        if(a.seqId != null){
            if(a.seqId===id)
            {
                return true;
            }
        }
        return false;
        }); 
        if((this.retOrderItems[id].qty - this.retOrderItems[id].qty_return) > 1){
          rQty = -1;
        }else{
          rQty = -1*(this.retOrderItems[id].qty - this.retOrderItems[id].qty_return);
        }
        if(rQty === 0){
          this.showAlert("Quantity is fully returned");
        }else{
          if(tempArr.length === 0){
            let item = {};
            let price = this.retOrderItems[id].standard_rate
            if(this.retOrderItems[id].tax == 'Standard'){
              price = price / this.taxBaseAmount
            }
            item.seqId = this.retOrderItems[id].seqId;
            item.barcode = this.retOrderItems[id].barcode;
            item.item_code = this.retOrderItems[id].item_code;
            item.item_name = this.retOrderItems[id].item_name;
            item.item_group = this.retOrderItems[id].item_group;
            item.tax = this.retOrderItems[id].tax;
            this.retOrderItems[id].qty_return = -1*rQty;
            item.qty = rQty;
            item.standard_rate = this.retOrderItems[id].standard_rate;
            item.price = -1*rQty < 1 ? this.retOrderItems[id].price : rQty * this.retOrderItems[id].standard_rate;
            this.orderItems.push(item)
          }else{
            if(rQty*tempArr[0].qty < this.retOrderItems[id].qty){
              let item = {};
              item = tempArr[0];
              item.qty = item.qty+rQty;
              this.retOrderItems[id].qty_return = this.retOrderItems[id].qty_return + (-1*rQty);

              //item.qty_return = item.qty_return - rQty;
              item.price =item.standard_rate*item.qty;
            }

          }
          this.calcOrderTotalAmount();

        }


    },
    deleteCurrentItem() {
      if(this.authorizedToChangePrice === 'Y'){
        this.currentItem = [];
        this.currentOrderDirty = true;
      }else{
        this.isVoidOpen = true;
      }
      if(this.orderItems.length === 0 && this.currentItem.length === 0){
        this.currentOrderDirty = false;
      }      
      this.authorizedToChangePrice = 'N'
    },    
    
    handleScale(){
        this.$router.push({ name: 'scale'});
    },   
    handleAdmin(){
        this.$router.push({ name: 'admin'});
    },   
    handleAddCustomer(){
        this.$router.push({ name: 'customers'});
    },   
    
    handleParked: async function(){
        this.showError= false;
        this.mainErrorMsg = "";
        this.clearOrderState();
        this.getParked();
        if(this.parked.length > 0){
          this.toggle = false;
          this.showParked = true;
          this.showDelivery = false;
          this.loyality = null;
          this.clearLoialityData();
          this.showDiscountRequested = false;
        }
    },   
    getParked: async function(){
        try{            
            let dataURL = this.apiURL+'Orders/getOrderByStatus';
            let parkedJson = {"appId": localStorage.appId, 'status': '1'};
            let response = await axios.post(dataURL, parkedJson);  
            if(response.data.status === 'success'){
              this.parked = response.data.results;

              this.parkedSize = this.parked.length;
            }
        }
        catch (error){
            console.log(error);
        }
    },   

    handleDeliveryOrders: async function(){
        this.showError= false;
        this.mainErrorMsg = "";
        this.getDelivery();

          this.toggle = false;
          this.showParked = false;
          this.showDiscountRequested = false;
          this.showDelivery = true;
          this.loyality = null;
          this.clearLoialityData();

      if(this.delivery.length > 0){
          this.toggle = false;
          this.showParked = false;
          this.showDiscountRequested = false;
          this.showDelivery = true;

          
        }
    },   
    getDelivery: async function(){
        try{
            
            let dataURL = this.apiURL+'Orders/getOrderByStatus';
            let discountJson = {"appId": localStorage.appId, 'status': '3'};
            let response = await axios.post(dataURL, discountJson);  
            if(response.data.status === 'success'){
              this.delivery = response.data.results;
              this.deliverySize = this.delivery.length;
            }
        }
        catch (error){
            console.log(error);
        }
    },   


    handleDiscountRequested: async function(){
        this.showError= false;
        this.mainErrorMsg = "";
        this.clearOrderState();
        this.getDiscountRequested();
        if(this.discountRequested.length > 0){
          this.toggle = false;
          this.showParked = false;
          this.showDelivery = false;
          this.showDiscountRequested = true;
        }
    },   
    getDiscountRequested: async function(){
        try{
            
            let dataURL = this.apiURL+'Orders/getOrderByStatus';
            let discountJson = {"appId": localStorage.appId, 'status': '2'};
            let response = await axios.post(dataURL, discountJson);  
            if(response.data.status === 'success'){
              this.discountRequested = response.data.results;
              this.discountRequestedSize = this.discountRequested.length;
              let discountRequestedR = [];
              for( var i = 0; i < this.discountRequested.length; i++){ 
                  if (this.discountRequested[i].discount > 0) { 
                    discountRequestedR.push(this.discountRequested[i]);
                  }
              }
              this.discountRequestedSizeR = discountRequestedR.length;
            }
        }
        catch (error){
            console.log(error);
        }
    },   

    handleMainPage() {
      this.$router.push({ name: 'main', query: { redirect: '/main' } });
    },
    showAlert(msg){
        Swal.fire({
          //position: 'middle',
          icon: 'error',
          title: msg,
          showConfirmButton: false,
          timer: 2000
        /*
        
        Swal.fire({
          title: this.jsonData.no_order_to_pay,
          icon: 'error',
          confirmButtonText: 'Cool'
        })


        */
        //this.$swal(this.jsonData.no_order_to_pay);
        })
    },
    handlePayCash() {
      if(this.orderItems.length > 0 || this.currentItem.length > 0){
        this.isPayCashOpen = true;
      }else{
        this.msgItems = [];
        this.msgItems.push({"id":"1", "cont":this.jsonData.no_order_to_pay});   
        this.showAlert(this.jsonData.no_order_to_pay);
        //this.isShowInfosOpen = true;
      }
    },
    handlePayCredit() {
      if(this.orderItems.length > 0 || this.currentItem.length > 0){
        this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);
        this.isPayCreditOpen = true;
      }else{
        this.msgItems = [];
        this.msgItems.push({"id":"1", "cont":this.jsonData.no_order_to_pay});
        //this.isShowInfosOpen = true;
        this.showAlert(this.jsonData.no_order_to_pay);
      }
    },
    handlePayAccount() {
      if(this.orderItems.length > 0 || this.currentItem.length > 0){
        this.isPayAccountOpen = true;
      }else{
        this.msgItems = [];
        this.msgItems.push({"id":"1", "cont":this.jsonData.no_order_to_pay});
        //this.isShowInfosOpen = true;
        this.showAlert(this.jsonData.no_order_to_pay);

      }
    },        
    handleSetQty() {
      if(this.currentItem.length===0){
        this.msgItems = [];
        this.msgItems.push({"id":"1", "cont":this.jsonData.no_currentItem});
        //this.isShowInfosOpen = true;      
        this.showAlert(this.jsonData.no_order_to_pay);

      }else{
        //this.$refs.searchProduct.unfocus();
        //this.$refs.currentItemQty.focus();
        this.$el.querySelector('#Barcode').focus = false;
        this.$el.querySelector('#currentItemQty').focus = true;
        this.setQty = false;
        this.setQuantity = true;
        this.currentItemQty = '';
      }
    },
    changCurrentItemQty() {
      if(this.currentItemQty === ''){
      }else{
        this.currentItem[0].qty = parseFloat(this.currentItemQty);
        this.currentItem[0].price = parseFloat(this.currentItemQty) * this.currentItem[0].standard_rate;
        this.currentItem[0].price_vat = parseFloat(this.currentItemQty) * this.currentItem[0].standard_rate*1.05;
        this.calcOrderTotalAmount();
      }
      this.setQty = true;
      this.setQuantity = false;

    },
    onInput(key) {
      if(key == 11){
        if(this.setQuantity){
          this.currentItemQty = (this.currentItemQty + '0').slice(0, this.maxLength);
        }else{            
          this.barcode = (this.barcode + '0').slice(0, this.maxLength);
        }
      }else
      {
        if(this.setQuantity){
          this.currentItemQty = (this.currentItemQty + key).slice(0, this.maxLength);
        }else{
          this.barcode = (this.barcode + key).slice(0, this.maxLength);
        }
      }
      //this.getProduct(this.barcode);

    },
    onDelete() {
        if(this.setCurrentPrice){
          
          this.currentItemPrice = (this.currentItemPrice + key).slice(0, this.maxLength);    
        }else{
          if(this.setQuantity){
            this.currentItemQty = (this.currentItemQty + key).slice(0, this.maxLength);
          }else{
            this.barcode = this.barcode.slice(0, this.barcode.length - 1);
          }
        }
    },
    onReset() {
        if(this.setCurrentPrice){
          this.currentItemPrice = "";    
        }else{
          if(this.setQuantity){
            this.currentItemQty = "";
          }else{
            this.barcode = "";
          }
        }      
    },
    getfirstOrderId(lastinvoicenumber)
    {
      this.lastinvoicenumber=lastinvoicenumber;
    },
   
  handleNewProduct()
  {
    this.isNewProductOpen = true
    this.msgItems = [];
    this.msgItems.push({"id":"1", "cont":this.jsonData.enter_barcode_or_name});

  },
    
    handleCloseCash: async function(){
      /*
      try{
          //Check for unhandled orders
          let dataURL = this.apiURL+'Orders/getOrdersCount';
          let ordersCountJason = {"appId": localStorage.appId,"userId":"9"};
          let response = await axios.post(dataURL, ordersCountJason); 
          let parkedOrdersCount = 0;
          let disReqOrdersCount = 0;
          let cashJson = {};
          cashJson = response.data.results;
          if(response.data.status==='success'){
            if(cashJson.parked != undefined){
              parkedOrdersCount = cashJson.parked;
            }
            if(cashJson.disrequest != undefined){
              disReqOrdersCount = cashJson.disrequest;
            }
            let msgStr ="";
            if(parkedOrdersCount !== 0 || disReqOrdersCount !== 0 || this.orderItems.length > 0 || this.currentItem.length > 0){
              this.msgItems = [];
              this.msgItems.push({"id":"1", "cont": this.jsonData.there_are});
              msgStr = msgStr + this.jsonData.there_are +", ";
              if(parkedOrdersCount !== 0){
                this.msgItems.push({"id":"1", "cont": parkedOrdersCount + " " +this.jsonData.parked_orders + " , " });
                msgStr = msgStr + parkedOrdersCount + " " +this.jsonData.parked_orders+", ";
              }
              if(disReqOrdersCount !== 0){
                this.msgItems.push({"id":"2", "cont":  disReqOrdersCount + " " + this.jsonData.discount_requested_orders + " , " });
                msgStr = msgStr + disReqOrdersCount + " " + this.jsonData.discount_requested_orders +", ";
              }
              if(this.orderItems.length > 0 || this.currentItem.length > 0){
                this.msgItems.push({"id":"3", "cont": " , " +  this.jsonData.current_order_not_empty});
                msgStr = msgStr + this.jsonData.current_order_not_empty +", ";
              }
              //this.isShowInfosOpen = true;
              this.showAlert(msgStr);

            }else{
              this.isCloseCashOpen = true;                  
            }
          }else{
            //show error msg
          }
      }
      catch (error){
          console.log(error);
      }
          */
              this.isCloseCashOpen = true;                  

    },
  handleCheckPrice()
  {
    this.isCheckPriceOpen = true
    this.msgItems = [];
    this.msgItems.push({"id":"1", "cont":this.jsonData.enter_barcode_or_name});
  },

   handleGiftCard()
    {
      if(this.orderItems.length>0 || this.currentItem.length>0){
        this.cashPop = true;
        this.isGiftCardOpen = true;
      }else{
        this.msgItems = [];
        this.msgItems.push({"id":"1", "cont":this.jsonData.no_order_to_pay});
        //this.isShowInfosOpen = true;
        this.showAlert(this.jsonData.no_order_to_pay);
      }
    },

    clearPayments: function(){
      if(parseFloat(this.grandTotalAmount).toFixed() !== 0){
        this.notPaidAmount =parseFloat(this.grandTotalAmount).toFixed();
        this.outstandingAmount =this.notPaidAmount.toString();

      }else{
        this.notPaidAmount = 0;
        this.outstandingAmount =this.notPaidAmount.toString();
      }
      this.cashAmount = 0;
      this.creditAmount = 0;
      this.accountAmount = 0;
      this.paidAmount = 0;
      this.balance = 0;
      this.discountAmount = 0;
    },
   goLogin()
    {
      this.$router.push({ name: 'login', query: { redirect: '/login' } });
    },
   handleFindInvoice()
    {
      this.$router.push({ name: 'find', query: { redirect: '/find' } });
    },

    requestDiscount1: async function(){
        try{
            //Order Payment API
            //const paymentDetails = [{"paymenttype":"cash", "amount":this.totalAmount, "accountid":"0"}, {"paymenttype":"credit", "amount":this.creditAmount, "accountid":"0"}, {"paymenttype":"account", "amount":this.accountAmount, "accountid":"0"}];
            let dataURL = this.apiURL+'Orders/payOrder';
            let loginJson = {"appId": localStorage.appId, 'orderId': this.orderId, "paymentDetails" : []};

            let response = await axios.post(dataURL, loginJson); 
            if(response.data.status === 'success'){
                console.log("Not saved");
            }
        }
        catch (error){
            console.log(error);
        }
        this.close();
    },     
  calcPaid()
    {
      this.paidAmount = 0;

      if(parseFloat(this.cashAmount) > 0){
        this.paidAmount = parseFloat(this.paidAmount)  +parseFloat(this.cashAmount);
      } 
      if(parseFloat(this.creditAmount) > 0){
        this.paidAmount = parseFloat(this.paidAmount)  +parseFloat(this.creditAmount);
      } 
      if(parseFloat(this.balance) > 0){
        this.paidAmount = parseFloat(this.paidAmount)  +parseFloat(this.balance);
      } 
      if(parseFloat(this.accountAmount) > 0){
        this.paidAmount = parseFloat(this.paidAmount)  +parseFloat(this.accountAmount);
      } 
      this.notPaidAmount = parseFloat(this.grandTotalAmount -this.paidAmount) ;
      this.msgItems = [];
      this.msgItems.push({"id":"1", "cont": this.jsonData.cahange});
      
      this.msgItems.push({"id":"1", "cont": (-1*(parseFloat(this.notPaidAmount).toFixed(2)))});
      let notPaid = this.notPaidAmount;
      this.outstandingAmount = Math.round(notPaid*100)/100;
      if(notPaid < 0){
        notPaid = -1*notPaid;
      }
      //console.log("notPaid", Math.round(notPaid*100)/100)

        if(this.notPaidAmount < 0 && Math.round(notPaid*100)/100 !== 0 ){
          //this.isShowInfosOpen = true;
        }
      //}
    },

  calcPaid_old()
    {
      this.notPaidAmount = parseFloat(this.grandTotalAmount).toFixed(2) - parseFloat(this.cashAmount).toFixed(2) - parseFloat(this.creditAmount).toFixed(2) - parseFloat(this.balance).toFixed(2) - parseFloat(this.accountAmount).toFixed(2) - parseFloat(this.discountAmount).toFixed(2);
      this.paidAmount = 0;
      if(parseFloat(this.cashAmount).toFixed(2) > 0){
        this.paidAmount = parseFloat(this.paidAmount).toFixed(2)  +parseFloat(this.cashAmount).toFixed(2);
      } 
      if(parseFloat(this.creditAmount).toFixed(2) > 0){
        this.paidAmount = parseFloat(this.paidAmount).toFixed(2)  +parseFloat(this.creditAmount).toFixed(2);
      } 
      if(parseFloat(this.balance).toFixed(2) > 0){
        this.paidAmount = parseFloat(this.paidAmount).toFixed(2)  +parseFloat(this.balance).toFixed(2);
      } 
      if(parseFloat(this.accountAmount).toFixed(2) > 0){
        this.paidAmount = parseFloat(this.paidAmount).toFixed(2)  +parseFloat(this.accountAmount).toFixed(2);
      } 
      this.msgItems = [];
      this.msgItems.push({"id":"1", "cont": this.jsonData.cahange});
      this.msgItems.push({"id":"1", "cont": (-1*(parseFloat(this.notPaidAmount))).toFixed(2)});
      //if(parseFloat(this.paidAmount).toFixed(2) >== parseFloat(this.grandTotalAmount).toFixed(2)){
        if(this.notPaidAmount < 0){
          this.isShowInfosOpen = true;
        }
      //}
    },

  fixNumber(num)
    {
      let mum2 = parseFloat(Math.round(num)).toFixed(2);
      return mum2;
    },
    getImgUrl(){
      let logoUrlStr;
      logoUrlStr = this.logoUrl;
      return logoUrlStr;
    },
    getLogo: async function(){
        try{            
            let dataURL = this.apiURL+'Orders/getInvoiceLogo';
            let logoJson = {"appId": localStorage.appId};
            let response = await axios.post(dataURL, logoJson); 
            if(response.data.status === 'success'){
                this.logoUrl=response.data.results.logourl;
            }
        }
        catch (error){
            console.log(error);
        }
    },    
  getCurrentDateTime(){
    let dateTimeStr = '';
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      dateTimeStr = year+'-'+month+'-'+day+' '+time;
    return dateTimeStr;
  },

  startOrderProcessing(status){
      this.processOrder('0');
      if(this.currentOrderId === ''){
        this.processPayment(this.lastinvoicenumber);
      }else{
        this.processPayment(this.currentOrderId);
      }

      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      if(parseFloat(this.notPaidAmount).toFixed(2) <= 0){
        let viaInvStr = '';        
        //viaInvStr = viaInvStr + '<img style="display: block;margin-left: auto; margin-right: auto;" src="'+this.logoUrl+'" width="100%" alt="Logo"></img>';
        //console.log("viaInvStr", viaInvStr);
        //viaInvStr = viaInvStr + '<p>Welcome into Our Restaurants<br/>We&#39;re at your Service</p>';
        //viaInvStr = viaInvStr + '</table>Open Time : '+time+' : via menus demo<br><br>';
        //viaInvStr = viaInvStr + '<hr>'
        //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr bgcolor="#EEE">';
        //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.logoUrl+'</td></tr></table>';         
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.invoiceHeader+'</td></tr>'; 
        viaInvStr = viaInvStr + '<tr><td>Order : '+this.lastinvoicenumber +' Order\'s Date : '+ day +"/"+ month + "/" + year +'<br></td></tr>';
        viaInvStr = viaInvStr + '<tr><td>Casheir : '+localStorage.username +'<br></td></tr></table>';

        //console.log("ooooooooooooooo", this.logoUrl);

        viaInvStr = viaInvStr + '<table align="center" width="100%" style="border-top: #000000 1px solid;border-bottom: #000000 1px solid;"><tr>';
        //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><img src="'+this.logoUrl+'"alt="Logo"/></td></tr>';
        //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6">'+this.invoiceHeader+'</td></tr>';
        viaInvStr = viaInvStr + '<td colspan=3 align="center"><b>Item</b></td>';
        viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Qty</b></td>';
        viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Unit</b></td>';
        viaInvStr = viaInvStr + '<td width="34%" align="center"><b>Total</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        this.orderItems.forEach(function(order) {
          viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+order.item_name+'</td><td width="33%" align="center">'+parseFloat(order.qty).toFixed(3)+'</td><td width="33%" align="center">'+(order.standard_rate*1.05).toFixed(2)+'</td><td width="33%" align="right">'+(order.price*1.05).toFixed(2)+'</td></tr>';
        });        
        this.currentItem.forEach(function(order) {
          viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+order.item_name+'</td><td width="33%" align="center">'+parseFloat(order.qty).toFixed(3)+'</td><td width="33%" align="center">'+(order.standard_rate*1.05).toFixed(2)+'</td><td width="33%" align="right">'+(order.price*1.05).toFixed(2)+'</td></tr>';
        });
        /*
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        viaInvStr = viaInvStr + '<tr style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+this.grandTotalAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Discount</b></td><td width="50%" align="right" colspan=3><b>'+this.discountAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>VAT</b></td><td width="50%" align="right" colspan=3><b>'+this.vatAmount.toFixed(2) +'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+this.netTotalAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Diff</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.diffAmount).toFixed(2)+'</b></td></tr>';
*/
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        viaInvStr = viaInvStr + '<tr style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.grandTotalAmount).toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Discount</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.discountAmount).toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>VAT</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.vatAmount).toFixed(2) +'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.netTotalAmount).toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Diff</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.diffAmount).toFixed(2)+'</b></td></tr>';

        //viaInvStr = viaInvStr + '<tr bgcolor="#EEE"><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+((parseFloat(this.totalOrderAmount)*105)/100).toFixed(2)+'</b></td></tr>';
        //viaInvStr = viaInvStr + '<tr bgcolor="#EEE" style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+((parseFloat(this.totalOrderAmount)*105)/100).toFixed(2) +'</b></td></tr>';
        /*
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan=3>Paid Amount</td></tr>';
        viaInvStr = viaInvStr + '<td width="50%" align="left" >Cash</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.cash+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" >Credit : Visa</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.credit+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" </td><td width="50%" align="left" >Account : '+this.customername+'</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.account+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" >Gift :</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.gift+'</td></tr>';
        */
       
        if(this.paymentMethod.cash>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left">Paid Amount</td><td width="33%" align="right" >Cash</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.cash)).toFixed(2)+'</td></tr>';
        }
        if(this.paymentMethod.credit>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Credit : Visa</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.credit)).toFixed(2)+'</td></tr>';
        }
        if(this.loyality !== null && this.name !== ""){
          viaInvStr = viaInvStr + '<tr><td width="33%"> </td><td width="33%" align="right" >Account :</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.account)).toFixed(2)+'</td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Customer name : </td><td align="left" width="33%" align="right" ><b>'+this.name+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Phone : </td><td align="left" width="33%" align="right" ><b>'+this.phone+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 1 : </td><td align="left" width="33%" align="right" ><b>'+this.line1+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 2 </td><td align="left" width="33%" align="right" >:<b>'+this.line2+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Area : </td><td align="left" width="33%" align="right" ><b>'+this.area+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> City : </td><td align="left" width="33%" align="right" ><b>'+this.city+'</b></td><td width="33%" align="right" ></td></tr>';
        } 
        if(this.paymentMethod.gift>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Gift :</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.gift)).toFixed(2)+'</td></tr>';
        }
        if(this.notPaidAmount!==0){
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left">Change</td><td width="50%" align="right" colspan=2>'+(-1*parseFloat(this.notPaidAmount)).toFixed(2)+'</td></tr>';
        }
        viaInvStr = viaInvStr + '</table>';
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.invoiceFooter+'</td></tr></table><br>'; 
        
        this.printElemm(viaInvStr);
        
      }
  },

  startReturnProcessing(status){
      this.processOrder('5');
      this.processPayment(this.lastinvoicenumber);
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let viaInvStr = '';        
        //viaInvStr = viaInvStr + '<img style="display: block;margin-left: auto; margin-right: auto;" src="'+this.logoUrl+'" width="100%" alt="Logo"></img>';
        //console.log("viaInvStr", viaInvStr);
        //viaInvStr = viaInvStr + '<p>Welcome into Our Restaurants<br/>We&#39;re at your Service</p>';
        //viaInvStr = viaInvStr + '</table>Open Time : '+time+' : via menus demo<br><br>';
        //viaInvStr = viaInvStr + '<hr>'
        //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr bgcolor="#EEE">';
        //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.logoUrl+'</td></tr></table>';         
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.invoiceHeader+'</td></tr>'; 
        viaInvStr = viaInvStr + '<tr><td>Order : '+this.lastinvoicenumber +' Order\'s Date : '+ day +"/"+ month + "/" + year +'<br></td></tr>';
        viaInvStr = viaInvStr + '<tr><td>Casheir : '+localStorage.username +'<br></td></tr></table>';

        //console.log("ooooooooooooooo", this.logoUrl);

        viaInvStr = viaInvStr + '<table align="center" width="100%" style="border-top: #000000 1px solid;border-bottom: #000000 1px solid;"><tr>';
        //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><img src="'+this.logoUrl+'"alt="Logo"/></td></tr>';
        //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6">'+this.invoiceHeader+'</td></tr>';
        viaInvStr = viaInvStr + '<td colspan=3 align="center"><b>Item</b></td>';
        viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Qty</b></td>';
        viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Unit</b></td>';
        viaInvStr = viaInvStr + '<td width="34%" align="center"><b>Total</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        this.orderItems.forEach(function(order) {
          viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+order.item_name+'</td><td width="33%" align="center">'+parseFloat(order.qty).toFixed(3)+'</td><td width="33%" align="center">'+(order.standard_rate*1.05).toFixed(2)+'</td><td width="33%" align="right">'+(order.price*1.05).toFixed(2)+'</td></tr>';
        });        
        this.currentItem.forEach(function(order) {
          viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+order.item_name+'</td><td width="33%" align="center">'+parseFloat(order.qty).toFixed(3)+'</td><td width="33%" align="center">'+(order.standard_rate*1.05).toFixed(2)+'</td><td width="33%" align="right">'+(order.price*1.05).toFixed(2)+'</td></tr>';
        });
        /*
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        viaInvStr = viaInvStr + '<tr style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+this.grandTotalAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Discount</b></td><td width="50%" align="right" colspan=3><b>'+this.discountAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>VAT</b></td><td width="50%" align="right" colspan=3><b>'+this.vatAmount.toFixed(2) +'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+this.netTotalAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Diff</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.diffAmount).toFixed(2)+'</b></td></tr>';
*/
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        viaInvStr = viaInvStr + '<tr style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.grandTotalAmount).toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Discount</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.discountAmount).toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>VAT</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.vatAmount).toFixed(2) +'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.netTotalAmount).toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Diff</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.diffAmount).toFixed(2)+'</b></td></tr>';

        //viaInvStr = viaInvStr + '<tr bgcolor="#EEE"><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+((parseFloat(this.totalOrderAmount)*105)/100).toFixed(2)+'</b></td></tr>';
        //viaInvStr = viaInvStr + '<tr bgcolor="#EEE" style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+((parseFloat(this.totalOrderAmount)*105)/100).toFixed(2) +'</b></td></tr>';
        /*
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan=3>Paid Amount</td></tr>';
        viaInvStr = viaInvStr + '<td width="50%" align="left" >Cash</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.cash+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" >Credit : Visa</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.credit+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" </td><td width="50%" align="left" >Account : '+this.customername+'</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.account+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" >Gift :</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.gift+'</td></tr>';
        */
       
        if(this.paymentMethod.cash>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left">Paid Amount</td><td width="33%" align="right" >Cash</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.cash)).toFixed(2)+'</td></tr>';
        }
        if(this.paymentMethod.credit>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Credit : Visa</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.credit)).toFixed(2)+'</td></tr>';
        }
        if(this.loyality !== null && this.name !== ""){
          viaInvStr = viaInvStr + '<tr><td width="33%"> </td><td width="33%" align="right" >Account :</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.account)).toFixed(2)+'</td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Customer name : </td><td align="left" width="33%" align="right" ><b>'+this.name+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Phone : </td><td align="left" width="33%" align="right" ><b>'+this.phone+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 1 : </td><td align="left" width="33%" align="right" ><b>'+this.line1+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 2 </td><td align="left" width="33%" align="right" >:<b>'+this.line2+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Area : </td><td align="left" width="33%" align="right" ><b>'+this.area+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> City : </td><td align="left" width="33%" align="right" ><b>'+this.city+'</b></td><td width="33%" align="right" ></td></tr>';
        } 
        if(this.paymentMethod.gift>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Gift :</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.gift)).toFixed(2)+'</td></tr>';
        }
        if(this.notPaidAmount!==0){
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left">Change</td><td width="50%" align="right" colspan=2>'+(-1*parseFloat(this.notPaidAmount)).toFixed(2)+'</td></tr>';
        }
        viaInvStr = viaInvStr + '</table>';
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.invoiceFooter+'</td></tr></table><br>'; 
        
        this.printElemm(viaInvStr);
  },

  startDeliveryOrderProcessing(){
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let viaInvStr = '';        
        //viaInvStr = viaInvStr + '<img style="display: block;margin-left: auto; margin-right: auto;" src="'+this.logoUrl+'" width="60" height="40" alt="Logo"></img>';
        //console.log("viaInvStr", viaInvStr);
        //viaInvStr = viaInvStr + '<p>Welcome into Our Restaurants<br/>We&#39;re at your Service</p>';
        //viaInvStr = viaInvStr + '</table>Open Time : '+time+' : via menus demo<br><br>';
        //viaInvStr = viaInvStr + '<hr>'
        //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr bgcolor="#EEE">';
        //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.logoUrl+'</td></tr></table>';         
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.invoiceHeader+'</td></tr>'; 
        viaInvStr = viaInvStr + '<tr><td>Order : '+this.lastinvoicenumber +' Order\'s Date : '+ day +"/"+ month + "/" + year +'<br></td></tr>';
        viaInvStr = viaInvStr + '<tr><td>Casheir : '+localStorage.username +'<br></td></tr></table>';

        //console.log("ooooooooooooooo", this.logoUrl);

        viaInvStr = viaInvStr + '<table align="center" width="100%" style="border-top: #000000 1px solid;border-bottom: #000000 1px solid;"><tr>';
        //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><img src="'+this.logoUrl+'"alt="Logo"/></td></tr>';
        //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6">'+this.invoiceHeader+'</td></tr>';
        viaInvStr = viaInvStr + '<td colspan=3 align="center"><b>Item</b></td>';
        viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Qty</b></td>';
        viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Unit</b></td>';
        viaInvStr = viaInvStr + '<td width="34%" align="center"><b>Total</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        this.orderItems.forEach(function(order) {
          viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+order.item_name+'</td><td width="33%" align="center">'+order.qty+'</td><td width="33%" align="center">'+(order.standard_rate*1.05).toFixed(2)+'</td><td width="33%" align="right">'+(order.price*1.05).toFixed(2)+'</td></tr>';
        });        
        this.currentItem.forEach(function(order) {
          viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+order.item_name+'</td><td width="33%" align="center">'+order.qty+'</td><td width="33%" align="center">'+(order.standard_rate*1.05).toFixed(2)+'</td><td width="33%" align="right">'+(order.price*1.05).toFixed(2)+'</td></tr>';
        });
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
        viaInvStr = viaInvStr + '<tr style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+this.grandTotalAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Discount</b></td><td width="50%" align="right" colspan=3><b>'+this.discountAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>VAT</b></td><td width="50%" align="right" colspan=3><b>'+this.vatAmount.toFixed(2) +'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+this.netTotalAmount.toFixed(2)+'</b></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Diff</b></td><td width="50%" align="right" colspan=3><b>'+parseFloat(this.diffAmount).toFixed(2)+'</b></td></tr>';
        
        //viaInvStr = viaInvStr + '<tr bgcolor="#EEE"><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>'+((parseFloat(this.totalOrderAmount)*105)/100).toFixed(2)+'</b></td></tr>';
        //viaInvStr = viaInvStr + '<tr bgcolor="#EEE" style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>'+((parseFloat(this.totalOrderAmount)*105)/100).toFixed(2) +'</b></td></tr>';
        /*
        viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan=3>Paid Amount</td></tr>';
        viaInvStr = viaInvStr + '<td width="50%" align="left" >Cash</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.cash+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" >Credit : Visa</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.credit+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" </td><td width="50%" align="left" >Account : '+this.customername+'</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.account+'</td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" >Gift :</td><td width="50%" align="right" colspan=2>'+this.paymentMethod.gift+'</td></tr>';
        */
       
        if(this.paymentMethod.cash>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left">Paid Amount</td><td width="33%" align="right" >Cash</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.cash)).toFixed(2)+'</td></tr>';
        }
        if(this.paymentMethod.credit>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Credit : Visa</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.credit)).toFixed(2)+'</td></tr>';
        }
        if(this.loyality !== null){
          viaInvStr = viaInvStr + '<tr><td width="33%"> </td><td width="33%" align="right" >Account :</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.account)).toFixed(2)+'</td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Customer name : </td><td align="left" width="33%" align="right" ><b>'+this.name+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Phone : </td><td align="left" width="33%" align="right" ><b>'+this.phone+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 1 : </td><td align="left" width="33%" align="right" ><b>'+this.line1+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 2 </td><td align="left" width="33%" align="right" >:<b>'+this.line2+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Area : </td><td align="left" width="33%" align="right" ><b>'+this.area+'</b></td><td width="33%" align="right" ></td></tr>';
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> City : </td><td align="left" width="33%" align="right" ><b>'+this.city+'</b></td><td width="33%" align="right" ></td></tr>';
        } 
        if(this.paymentMethod.gift>0){
          viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Gift :</td><td width="33%" align="right" >'+(parseFloat(this.paymentMethod.gift)).toFixed(2)+'</td></tr>';
        }
        if(this.notPaidAmount!==0){
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left">Change</td><td width="50%" align="right" colspan=2>'+(-1*parseFloat(this.notPaidAmount)).toFixed(2)+'</td></tr>';
        }
        viaInvStr = viaInvStr + '</table>';
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+this.invoiceFooter+'</td></tr></table>'; 
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>'; 
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>'; 
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>'; 
        viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>'; 
        this.printElemm(viaInvStr);
  },

printCashDetail(cashDetail)
{
    let cashDetailVal = [];
    cashDetailVal = cashDetail; 
    const nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth()+1;
    let day = nowDate.getDate();
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var cashier = localStorage.username;
    let viaInvStr = '';
    let totalCash = 0;

    viaInvStr = viaInvStr + '<p>VIAMENU Restaurant<br/>Cashier Closing</p>';
    viaInvStr = viaInvStr + '<tr><td> Date : '+ day +"/"+ month + "/" + year + ' ' + time +'<br></td></tr>';
    viaInvStr = viaInvStr + '<tr><td> Cashier : '+ cashier +'<br></td></tr>';
    
    viaInvStr = viaInvStr + '<table align="center" width="100%"><tr bgcolor="#EEE">';
    viaInvStr = viaInvStr + '<td colspan=3 align="center"><b>CURRENCY TYPES</b></td>';
    viaInvStr = viaInvStr + '<td width="33%" align="center"><b>COUNT</b></td>';
    viaInvStr = viaInvStr + '<td width="33%" align="center"><b>VALUE</b></td>';
    viaInvStr = viaInvStr + '</tr>';
    cashDetailVal.forEach(function(cashDetailItem) {
      viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+cashDetailItem.value+'</td><td width="33%" align="center">'+cashDetailItem.count+'</td><td width="33%" align="center">'+cashDetailItem.value+'</td></tr>';
      totalCash = totalCash + (cashDetailItem.value*cashDetailItem.count);
    });        
    viaInvStr = viaInvStr + '<tr bgcolor="#EEE"><td width="50%" align="left" colspan=2><b>TOTAL:</b></td><td width="50%" align="right" colspan=3><b>'+totalCash +'</b></td></tr>';
    this.printElemm(viaInvStr);
    this.$router.push({ name: 'login'});
},

  setAccountAmount(accountAmount1)
    {
      this.accountAmount = accountAmount1;
      this.calcPaid();
      if(parseFloat(this.notPaidAmount) < 0 || parseFloat(this.notPaidAmount) == 0){
        this.startOrderProcessing();
      }

      //if(parseFloat(this.paidAmount).toFixed(2) >= parseFloat(this.grandTotalAmount).toFixed(2)){
      //     this.startOrderProcessing();
      //  }

      //if(parseFloat(this.paidAmount).toFixed(2) >= parseFloat(this.grandTotalAmount).toFixed(2)){
       //this.startOrderProcessing();
      //}
    },

  setCustomerName(customername)
    {
      this.customername = customername;
    },
  setCustomerId(customerid)
    {
      this.accCustomerid = customerid;
    },
    
  setCustomernumber(customernumber)
    {
      this.customernumber = customernumber;
      this.customerId=customernumber;
    },

  setCreditAmount(creditAmount)
    {
      this.creditAmount=parseFloat(creditAmount).toFixed(2);
      this.calcPaid();
      if(this.notPaidAmount < 0 || this.notPaidAmount == 0){
          this.startOrderProcessing();
      }

      //if(parseFloat(this.paidAmount).toFixed(2) >= parseFloat(this.grandTotalAmount).toFixed(2)){
      // this.startOrderProcessing();
      //}
    },
  handleProcessReturn() {
    this.isReasonOpen = true;
  },
    setReason(reason){
      this.reason = reason;
      this.isVoidOpen = true;
    },
   setVoidUserId(userId)
    {
      this.voidUserId=parseInt(userId);
    },

   setVoidPermission(authorizedToChangePrice)
    {
      this.authorizedToChangePrice=authorizedToChangePrice;
      if(this.authorizedToChangePrice === 'Y'){
        this.processReturn(5); 
      }else{
        this.showAlert("You have not requirted permission to do this action");
      }
      this.authorizedToChangePrice = 'N'
    },

  processReturnOrder(cashAmount)
    {
      this.accountAmount=this.grandTotalAmount;
      this.calcPaid();
      if(this.notPaidAmount < 0 || this.notPaidAmount == 0){
        this.startReturnProcessing();
      }

      //if(parseFloat(this.paidAmount).toFixed(2) >= parseFloat(this.grandTotalAmount).toFixed(2)){
      //    this.startOrderProcessing();
      //}
      //if(parseFloat(this.paidAmount).toFixed(2) >= parseFloat(this.grandTotalAmount).toFixed(2)){
       //this.startOrderProcessing();
      //}
    },

  setCashAmount(cashAmount)
    {
      this.cashAmount=parseFloat(cashAmount).toFixed(2);
      this.calcPaid();
      if(this.notPaidAmount < 0 || this.notPaidAmount == 0){
        this.startOrderProcessing();
      }

      //if(parseFloat(this.paidAmount).toFixed(2) >= parseFloat(this.grandTotalAmount).toFixed(2)){
      //    this.startOrderProcessing();
      //}
      //if(parseFloat(this.paidAmount).toFixed(2) >= parseFloat(this.grandTotalAmount).toFixed(2)){
       //this.startOrderProcessing();
      //}
    },

  setNewProductData(newProductData)
    {
      this.products.push({
        "item_name":newProductData.item_name,
        "arabic_item_name":newProductData.item_name,
        "item_group":newProductData.item_name,
        "barcode":newProductData.newproductbarcode,
        "standard_rate":newProductData.newproductprice,
        "item_code":newProductData.newproductbarcode,
        })
        let newProduct = {};
        newProduct.item_name = newProductData.item_name;
        newProduct.arabic_item_name = newProductData.item_name;
        newProduct.item_group = newProductData.item_name;
        newProduct.barcode = newProductData.newproductbarcode;
        newProduct.standard_rate = newProductData.newproductprice;
        newProduct.item_code = newProductData.newproductbarcode;
        newProduct.price = newProductData.price;
        //newProduct.standard_rate_vat = parseFloat(newProductData.newproductprice*1.05).toFixed(2);
        //newProduct.price_vat = parseFloat(newProductData.newproductprice*1.05).toFixed(2);
        if(this.products.length === 1){          
            this.addProductToOrder(newProduct);
            this.products=[];
            this.barcode = '';
        }
    },


  setGiftCardInfos(giftCardInfos)
    {
      this.loyality = null;
      this.giftCardInfos=giftCardInfos;
      if(this.giftCardInfos.status === 'success'){
        this.customerId = this.giftCardInfos.results[0].customernumber;
      }else{
      }
      this.giftcardnumber = this.giftCardInfos.results[0].giftcardnumber;
      this.giftcardname = this.giftCardInfos.results[0].giftcardname;
      this.balance = this.giftCardInfos.results[0].balance;
      this.calcPaid();
      if(this.notPaidAmount < 0 || this.notPaidAmount == 0){
        this.startOrderProcessing();
      }
    },
    clearLoialityData()
    {
      this.loyality = null;
      this.showloyality = false;
      this.giftCardInfos = null;
      this.loyality=null;
      this.dis_percentage = 0;
      this.customernumber = "";
      this.name = "";
      this.gender = "";
      this.email = "";
      this.phone = "";
      this.customerId = 0;
      this.customer = 0;

      this.line1 = "";
      this.line2 = "";
      this.city = "";
      this.area = "";
      this.totalpoints = "";
      this.customersince = "";

    },
    setLoialityPoints(loyality)
    {
      this.giftCardInfos = null;
      this.loyality=loyality;
      this.showloyality = true;
      if(this.loyality.status === 'success'){
      }else{
        console.log("Not Found");
      }
      //this.dis_percentage = parseFloat(this.loyality.results[0].dis_percentage).toFixed(2);
      this.customernumber = this.loyality.results[0].customernumber;
      this.name = this.loyality.results[0].name;
      this.gender = this.loyality.results[0].gender;
      this.email = this.loyality.results[0].email;
      this.phone = this.loyality.results[0].phone;
      this.accCustomerid = this.loyality.results[0].id;
      this.line1 = this.loyality.results[0].line1;
      this.line2 = this.loyality.results[0].line2;
      this.city = this.loyality.results[0].city;
      this.area = this.loyality.results[0].area;

      this.totalpoints = this.loyality.results[0].totalpoints;
      this.customersince = this.loyality.results[0].customersince;

    },
    async handleURA() {
      this.showInfo("Processing Invoice With URA")
      let uraJson = {
        username: localStorage.username,
        invoiceId: this.currentOrderId
      };
      let dataURL = this.apiURL + 'SendToEfris/syncReturnsInvoice';
      let response = await axios.post(dataURL, uraJson);
      if (response.data.status === 'success') {
        this.showSuccess("Synced To URA");
        } else {
          this.showAlert("Error Syncing With URA")
        }
    },
  async printOriginalOrder(){
  this.invoiceHeader = " ";
  this.invoiceFooter = "";
    if (this.posData.efris_on != '0') {
      await this.handleURA();
      this.sharedPrintOrder(false, this.currentOrderId, this.orderDate, this.invoiceHeader, 
  this.invoiceFooter, this.orders[0], this.orderItems, [], this.grandTotalAmount, this.discountAmount, 
  this.vatAmount, this.netTotalAmount, this.diffAmount, this.cashAmount, this.creditAmount, this.accountAmount, 
  this.balance, this.name, this.phone, this.line1, this.line2, this.area, this.city)
    } else {
        this.sharedPrintOrder(false, this.currentOrderId, this.orderDate, this.invoiceHeader, 
  this.invoiceFooter, this.orders[0], this.orderItems, [], this.grandTotalAmount, this.discountAmount, 
  this.vatAmount, this.netTotalAmount, this.diffAmount, this.cashAmount, this.creditAmount, this.accountAmount, 
  this.balance, this.name, this.phone, this.line1, this.line2, this.area, this.city)
    }

  
},
    
    processPayment: async function(orderId){
        try{
            const paymentDetails = [{"paymenttype":"cash", "amount":parseFloat(this.cashAmount).toFixed(2), "accountid":"0"}, {"paymenttype":"credit", "amount":parseFloat(this.creditAmount).toFixed(2), "accountid":"0"}, {"paymenttype":"account", "amount":parseFloat(this.grandTotalAmount).toFixed(2), "accountid":this.customerId}, {"paymenttype":"giftcard", "cardnumber":this.giftcardnumber, "amount":parseFloat(this.balance).toFixed(2), "accountid":"0"}];
            //this.paymentMethod.push({"paymenttype":"cash", "amount":this.cashAmount, "accountid":"0"});
            //this.paymentMethod.push({"paymenttype":"credit", "amount":this.creditAmount, "accountid":"0"});
            //this.paymentMethod.push({"paymenttype":"account", "amount":this.accountAmount, "accountid":"0"});
            let dataURL = this.apiURL+'Orders/payOrder';
            let loginJson = {"appId": localStorage.appId,customerId: this.customerId, 'orderId': orderId, "added_by": localStorage.userId, "paymentDetails" : paymentDetails};
            let response = await axios.post(dataURL, loginJson); 
            let totalAmount = 0;
            if(response.data.status === 'success'){
              this.updateCustomerBalance(this.customerId, parseFloat(this.grandTotalAmount).toFixed(2));
              localStorage.customerId = 0;
              //this.orderItems = [];
              //this.currentItem = [];
              //this.totalOrderAmount = 0;
              await this.printOriginalOrder();
              this.clearPayments();
              //this.currentOrderId = '';
              this.clearOrderState();
              this.showChange = true;
              this.currentOrderDirty = false;
              this.loyality = null;
              this.clearLoialityData();

              this.accCustomerid = 0;
              this.giftCardInfos = null;
              this.customerId = '';
              this.customernumber = '';
              this.$router.replace('/find');

          }
        }
        catch (error){
            console.log(error);
        }
    },    
    updateCustomerBalance: async function(account, amount){
        try{
            let dataURL = this.apiURL+'Orders/updateCustomerBalance';
            let customerBalanceJson = {"appId":"7","customerId":account,"balance":amount};
            let response = await axios.post(dataURL, customerBalanceJson); 
            if(response.data.status==='success'){
                
            }
        }
        catch (error){
            console.log(error);
        }
    },

    processDeliveryOrder: async function(status){
        try{
            //Gift Card API
            let dataURL = this.apiURL+'Customers/checkCustomerCredit';
            let accountJson = {"appId":localStorage.appId, 'customernumber': this.customernumber, 'customer_id': this.customerId };
            let response = await axios.post(dataURL, accountJson); 
            if(response.data.void===true){
                this.customername = response.data.customername;
                this.email = response.data.email;
                this.phone = response.data.phone;
                this.customerAddress = response.data.city+"-"+response.data.area+"-"+response.data.line1+"-"+response.data.line2;
                this.cashAmount = this.grandTotalAmount;
                this.calcPaid();
                if(this.paidAmount >= this.grandTotalAmount){
                  this.startOrderProcessing();
                }
                this.clearOrderState();
          //this.showError= true;
              //this.mainErrorMsg = "Customer name"+this.customername;
              //this.processOrder(3)
            }else{
              this.showError= true;
              this.mainErrorMsg = "Please check the customer information";
            }
        }
        catch (error){
            console.log(error);
        }
    },
    processReturn: async function(status){
      this.totalPaymentAmount =this.grandTotalAmount; 
      const nowDate = new Date();
      let orderDetailItems = [];
      let newOrderId = '';
      if(this.currentOrderId === ''){
        newOrderId = -1;
      }else{
        newOrderId = this.currentOrderId;
      }
      try{
          if(this.orderItems.length>0){
            this.orderItems.forEach(function(order) {
              orderDetailItems.push({"barcode":order.barcode,"item_group":order.item_group,"item_code":order.item_code,"item_name":order.item_name,"qty":order.qty,"standard_rate":parseFloat(order.standard_rate).toFixed(2),"price":parseFloat(order.price).toFixed(2)});
            });        
          }
          if(this.currentItem.length>0){
            this.currentItem.forEach(function(order) {
              orderDetailItems.push({"barcode":order.barcode,"item_group":order.item_group,"item_code":order.item_code,"item_name":order.item_name,"qty":order.qty,"standard_rate":parseFloat(order.standard_rate).toFixed(2),"price":parseFloat(order.price).toFixed(2)});
            });        
          }
          let orderDateTime = '2022-04-23 15:59:22';
          orderDateTime = this.getCurrentDateTime();
          this.orderHeader.appId = localStorage.appId;
          this.orderHeader.userId = localStorage.userId;
          this.orderHeader.username = localStorage.username;
          this.orderHeader.orderId = newOrderId;
          this.orderHeader.original_invoice =this.orders[0].orderId;
          this.orderHeader.orderDate = orderDateTime;
          this.orderHeader.totalamount = parseFloat(this.grandTotalAmount).toFixed(2);
          this.orderHeader.customerId = this.customerId;
          this.orderHeader.returnReason = this.reason;
          this.orderHeader.status = status;
          //this.orderHeader.customerId = this.customernumber;          
          this.orderHeader.customer_name = this.name;          
          this.orderHeader.orderDetail = orderDetailItems;
          let orderJason = JSON.stringify(this.orderHeader);
          let itIsOk = true;
          if(itIsOk){
              let dataURL = this.apiURL+'Orders/createOrder';
              let response = await axios.post(dataURL, orderJason); 
              if(response.data.status === 'success'){
                this.currentOrderId = response.data.invoice;
                this.processPayment(this.currentOrderId);

              }else{
                this.showAlert("Error");
                
          }              
          }
      }
      catch (error){
          console.log(error);
      }
    },

    processOrder1: async function(status){
      this.totalPaymentAmount =this.grandTotalAmount; 
      const nowDate = new Date();
      let orderDetailItems = [];
      let newOrderId = '';
      if(this.currentOrderId === ''){
        newOrderId = parseInt(this.lastinvoicenumber)+1;
        this.lastinvoicenumber = newOrderId;
      }else{
        newOrderId = this.currentOrderId;
      }
      try{
          if(this.orderItems.length>0){
            this.orderItems.forEach(function(order) {
              orderDetailItems.push({"item_code":order.item_code,"item_name":order.item_name,"qty":order.qty,"standard_rate":parseFloat(order.standard_rate).toFixed(2),"price":parseFloat(order.price).toFixed(2)});
            });        
          }
          if(this.currentItem.length>0){
            this.currentItem.forEach(function(order) {
              orderDetailItems.push({"item_code":order.item_code,"item_name":order.item_name,"qty":order.qty,"standard_rate":parseFloat(order.standard_rate).toFixed(2),"price":parseFloat(order.price).toFixed(2)});
            });        
          }

          let orderDateTime = '2022-04-23 15:59:22';
          orderDateTime = this.getCurrentDateTime();
          this.orderHeader.appId = localStorage.appId;
          this.orderHeader.userId = localStorage.userId;
          this.orderHeader.orderId = newOrderId;
          this.orderHeader.orderDate = orderDateTime;
          this.orderHeader.discount = this.discountAmount;
          this.orderHeader.totalamount = parseFloat(this.grandTotalAmount).toFixed(2);
          this.orderHeader.customerId = this.phone;
          this.orderHeader.status = status;
          //this.orderHeader.customerId = this.customernumber;          
          this.orderHeader.customer_name = this.name;          
          this.orderHeader.orderDetail = orderDetailItems;
          let orderJason = JSON.stringify(this.orderHeader);
          let itIsOk = true;
          if(status === "3" && this.loyality === null){
            itIsOk = false;
            this.showAlert("Please select a customer");
           }
          if(status === "2" && this.discountAmount!==0){
            itIsOk = false;
            this.showError= true;
            this.mainErrorMsg = "This invoice alredy has a discount";
          }
          if(itIsOk){
              let dataURL = this.apiURL+'Orders/createOrder';
              let response = await axios.post(dataURL, orderJason); 
              if(response.data.status === 'success'){
                if(status === "2"){
                  this.discountRequestedSize = this.discountRequestedSize +1;   
                }
                if(status === "1"){
                  this.parkedSize = this.parkedSize +1;   
                }
                if(status === "3"){
                 this.startDeliveryOrderProcessing();
                }
                this.clearOrderState();
              }            
          }
      }
      catch (error){
          console.log(error);
      }
    },
    clearOrderState() {
      this.orderItems = [];
      this.currentItem = [];
      this.clearPayments();
      this.notPaidAmount = 0;
      this.discountAmount = 0;
      this.vatAmount = 0;
      this.netTotalAmount = 0;
      this.grandTotalAmount = 0;
      this.diffAmount = 0;
      this.outstandingAmount =this.notPaidAmount.toString();
      this.dis_percentage = 0;
      this.prompMinimum_total = 0;
      this.promoDiscount = 0;
      //this.totalOrderAmount = 0;
      this.currentOrderId = '';
       // this.customer = "";
      this.currentOrderDirty = false;
      //this.orderParkStatus = "";
      this.clearLoialityData();
    },

    clearOrderState_old() {
      this.orderItems = [];
      this.currentItem = [];
      this.clearPayments();
      this.notPaidAmount = 0;
      this.discountAmount = 0;
      this.vatAmount = 0;
      this.netTotalAmount = 0;
      this.grandTotalAmount = 0;
      this.diffAmount = 0;
      this.outstandingAmount =this.notPaidAmount.toString();
      this.dis_percentage = 0;
      this.prompMinimum_total = 0;
      this.promoDiscount = 0;
      //this.totalOrderAmount = 0;
      this.currentOrderId = '';
      this.currentOrderDirty = false;
      this.clearLoialityData();
    },
    
    processOrderT: async function(status, newOrderId){      
      this.totalPaymentAmount =this.grandTotalAmount; 
      const nowDate = new Date();
      let orderDetailItems = [];
      if(this.orderItems.length>0){
        this.orderItems.forEach(function(order) {
          orderDetailItems.push({"item_name":order.item_name,"item_code":order.item_code,"barcode":order.barcode,"qty":order.qty,"standard_rate":order.standard_rate,"price":order.price});
        });        
      }
      if(this.currentItem.length>0){
          let order = this.currentItem[0];
          orderDetailItems.push({"item_name":order.item_name,"item_code":order.item_code,"barcode":order.barcode,"qty":order.qty,"standard_rate":order.standard_rate,"price":order.price});
      }
      let orderJason = JSON.stringify({
        "appId": localStorage.appId,
        "userId": "9",
        "orderId": newOrderId,
        "orderDate": nowDate,
        "discount": 0,
        "totalamount": this.grandTotalAmount,
        "customerId": "1212",
        "status": status,
        "orderDetail": orderDetailItems                
        })
        this.orderItems = [];
        this.currentItem = [];
        this.clearPayments();
        this.notPaidAmount = 0;
        this.outstandingAmount =this.notPaidAmount.toString();
        this.totalOrderAmount = 0;
        this.currentOrderId = '';
        if(orderDetailItems.length > 0){
          if(status === '1'){
            this.parked.push({"orderId":newOrderId, "orderAmount":this.totalPaymentAmount, "orderDetailItems":orderDetailItems});
          }
          if(status === '2'){
            this.discountRequested.push({"orderId":newOrderId, "orderAmount":this.totalPaymentAmount, "orderDetailItems":orderDetailItems});
          }                        
        }
      },              
      clearOrder: function () {
        this.orderItems = [];
        this.isPaymentOpen = !this.isPaymentOpen
      },        
      greet: function (event) {
          if (event) {
              alert(event.target.tagName)
          }
      },        
      saveNewPrice: function(barcode){
          let tempOrderItems = [];
          tempOrderItems = this.orderItems.filter(function(a){
              if(a.barcode != null){
                  if(a.barcode.toLowerCase()===barcode)
                  {
                      return true;
                  }
              }
              return false;
              }                
          );                
          //console.log(localStorage.authorizedToChangePrice);
          if(tempOrderItems.length>0){
              tempOrderItems[0].price= this.editedPrice;
              this.toggle = true;
            localStorage.removeItem('authorizedToChangePrice');
            this.calcOrderTotalAmount();
          }
      },

      hideBtnShowText: function(barcode){
        this.authorizedToChangePrice = localStorage.authorizedToChangePrice;
          //this.authorizedToChangePrice = 'N';
        if(this.authorizedToChangePrice==='Y'){
          this.$el.querySelector('#Barcode').focus = false;
          this.$el.querySelector('#currentItemQty').focus = false;
          this.$el.querySelector('#currentItemPrice').focus = true;

            let tempOrderItems = [];
            tempOrderItems = this.orderItems.filter(function(a){
                if(a.barcode != null){
                    if(a.barcode.toLowerCase()===barcode)
                    {
                        return true;
                    }
                }
                return false;
                }                
            );                
            if(tempOrderItems.length===1){
              this.editedRoderItem = tempOrderItems;
              this.toggle = false;
              this.editedPrice = tempOrderItems[0].price;
            }
          }else{
              this.isVoidOpen = true;
          }
      },
      getProduct_array: async function(barcodeVar){
        try{
          let h = parseInt(barcodeVar)
          let foundProd = this.products[h];
          let foundProds = [];
          foundProds.push(foundProd)
          let vv = {};
          eval("vv.a10001 = foundProd")

          JSON.stringify(vv) 
            if(foundProds.length === 1){          
                this.addProductToOrder(foundProd);
                //this.products=[];
                this.barcode = '';
            }else{
              let newBacode = '';
              let item_price = '';
              let item_qty = '';
              let newBacodeType = '';              
              newBacodeType = barcodeVar.substring(0,2);
              newBacode = barcodeVar.substring(2,7);
              if(newBacodeType === '99'){
                item_price = barcodeVar.substring(7,barcodeVar.length);
              }else if(newBacodeType === '97'){
                item_qty = barcodeVar.substring(7,barcodeVar.length);
              }
              if(barcodeVar === "9999999"){
                  this.isNewProductOpen = true;
              }else{
                this.getNewProduct(newBacode, item_qty, item_price);
              }
            }
        }
        catch (error){
            console.log(error);
        }
      },      
      getPromotion: async function(product){
          let promo_data = {};
          let currentPromotion = [];
          let order_item = {};
          promo_data.minimum_total = 0;
          promo_data.discount = 0;
          order_item.item_name = product.item_name;
          order_item.arabic_item_name = product.arabic_item_name;
          order_item.item_group = product.item_group;
          order_item.barcode = product.barcode;
          order_item.standard_rate = product.standard_rate;
          order_item.item_code = product.item_code;
          order_item.price = product.price;
          order_item.item_discount = product.item_discount;
          currentPromotion = this.promotions.filter(function(a){
            if(product.item_group !== null){
              if(a.item_group.toLowerCase()===product.item_group.toLowerCase()){
                  return true;
              }
            }
            return false;
          });             
             
          if(currentPromotion.length>0){
            if(currentPromotion[0].minimum_total>0 && currentPromotion[0].discount>0){
              //order_item.item_discount = currentPromotion[0].discount;

              order_item.item_discount = parseFloat(currentPromotion[0].discount)*order_item.price/100;
              this.prompMinimum_total = currentPromotion[0].minimum_total;
            }


          }else{

            try{
                let dataURL = this.apiURL+'Products/getPromos';
                let response = await axios.post(dataURL, {"appId": localStorage.appId, "item_group": product.item_group}); 
                
                if(response.data.status === 'success'){
                  if(response.data.results.promotions.length > 0){
                    promo_data.minimum_total = response.data.results.promotions[0].minimum_total;
                    promo_data.discount = response.data.results.promotions[0].discount;
                    this.promotions.push({
                      "item_group":product.item_group, 
                      "minimum_total":promo_data.minimum_total,
                      "discount":promo_data.discount,
                      });
                    if(promo_data.minimum_total>0 && promo_data.discount>0){
                      //order_item.item_discount = promo_data.discount;
                      order_item.item_discount = parseFloat(promo_data.discount)*order_item.price/100;
                      this.prompMinimum_total = promo_data.minimum_total;
                    }else{
                      order_item.item_discount = 0;
                    }
                  }                  
                }else{
                      order_item.item_discount = 0;
                }
            }
            catch (error){
                console.log(error);
            }
          }

          this.addProductToOrder(order_item);
          this.products=[];
          this.barcode = '';
      },      
      getProductName: async function(barcode){
          let barcodeRes = "";
        try{
            let dataURL = this.apiURL+'Products/findProductLocal?appId=7&barcode='+barcode;
            let response = await axios.post(dataURL, {"appId": localStorage.appId, "barcode": barcode}); 
            if(response.data.status === "success"){
              barcodeRes = response.data.results.products[0].item_name;
            }
          }
        catch (error){
            console.log(error);
        }
        return barcodeRes;
      },      

      getProduct: async function(barcodeVar){
        let prodName = this.getProductName(barcodeVar);
        let tempOrderItems = [];
        if(barcodeVar !== ''){
          try{
            tempOrderItems = this.retOrderItems.filter(function(a){
              if(barcodeVar !== null){
                if(a.item_name===prodName){
                    return true;
                }
              }
            return false;
            });                
            if(tempOrderItems.length >0){
                this.products= tempOrderItems;
                if(this.products.length === 1){ 
                  let addedProduct = {};
                  addedProduct.item_name = this.products[0].item_name;
                  addedProduct.arabic_item_name = this.products[0].arabic_item_name;
                  addedProduct.item_group = this.products[0].item_group;
                  addedProduct.barcode = this.products[0].barcode;
                  addedProduct.standard_rate = this.products[0].standard_rate;
                  addedProduct.item_code = this.products[0].item_code;
                  addedProduct.price = this.products[0].price;
                  addedProduct.item_discount  = 0;
                  this.addProductToOrder(addedProduct);
                  this.calcOrderTotalAmount();

                  this.products=[];
                  this.barcode = '';
                  //this.getPromotion(addedProduct);
                }else{
                  let newBacode = '';
                  let item_price = '';
                  let item_qty = '';
                  let newBacodeType = '';              
                  newBacodeType = barcodeVar.substring(0,2);
                  newBacode = barcodeVar.substring(2,7);
                  if(newBacodeType === '99'){
                    item_price = barcodeVar.substring(7,barcodeVar.length);
                    this.getNewProduct(newBacode, item_qty, item_price);
                  }else if(newBacodeType === '97'){
                    item_qty = barcodeVar.substring(7,barcodeVar.length);
                    this.getNewProduct(newBacode, item_qty, item_price);
                  }else if(barcodeVar === "7777777"){
                      this.isNewProductOpen = true;
                  }else{
                    this.showAlert("Item not found please try again");
                  }
                }

              }
          }
          catch (error){
              console.log(error);
          }


        }
      },      
      getNewProduct: async function(newBarcode, item_qty, item_price){
        try{
            let dataURL = this.apiURL+'Products/findProductLocal?appId=7&barcode='+newBarcode;
            let response = await axios.post(dataURL, {"appId": localStorage.appId, "barcode": newBarcode}); 
            this.products= response.data.results.products;

            if(this.products.length===1){
              let price = 0;
              let standard_rate = parseFloat(this.products[0].standard_rate).toFixed(2);
              let qty = 0;            
              if(item_price !== ''){
                price = parseFloat((item_price/1000)).toFixed(2);
                if(standard_rate>0){
                  qty = (item_price*1000)/(standard_rate*1000)
                }
              }else if(item_qty !== ''){
                qty = parseFloat((item_qty/10000)).toFixed(3);
                price = parseFloat(qty*standard_rate).toFixed(2);

              }
              this.seqId = this.seqId+1;
              if(this.currentItem.length!==0)
              {
                this.orderItems.push(this.currentItem[0]);
                this.currentItem = [];
              }
              this.orderItems.push({"seqId":this.seqId, "item_discount":0, "item_code":this.products[0].item_code,"item_name":this.products[0].item_name, "item_group":this.products[0].item_group, "barcode":newBarcode, "price":parseFloat(price).toFixed(2), "standard_rate":parseFloat(this.products[0].standard_rate).toFixed(2),"qty":parseFloat(qty).toFixed(3)});
              this.calcOrderTotalAmount();
              this.products=[];
              this.barcode = '';
            }
        }
        catch (error){
            console.log(error);
        }
      },      
    calcOrderTotalAmount: function(){
        this.vatAmount = this.calcOrderVatTotal();
        this.netTotalAmount = this.calcOrderNetTotal();
        
        this.grandTotalAmount = this.netTotalAmount + this.vatAmount- this.calcOrderDiscount();
        this.calcPaid();
    },

    calcOrderNetTotal: function () {
      let orderAmount = 0;
      if (this.orderItems.length > 0) {
        let tax = this.taxBaseAmount;
        this.orderItems.forEach(function (order) {
          let price = order.standard_rate;
          if(order.tax == 'Standard' || order.tax != 1){
            price = order.standard_rate / tax;
          }
          
          orderAmount = orderAmount + Math.round(price * order.qty);
        });
      }
      if (this.currentItem.length > 0) {
        let tax = this.taxBaseAmount;
        this.currentItem.forEach(function (order) {
          let price = order.standard_rate;
          if(order.tax == 'Standard' || order.tax != 1){
            price = order.standard_rate / tax;
          }
          
          orderAmount = orderAmount + Math.round(price * order.qty);
        });
      }
      return orderAmount;
    },
     getTaxAmount: async function () {
      try {

        let dataURL = this.apiURL + 'Products/getTaxAmount';
        let response = await axios.post(dataURL, {});
        if (response.data.status === 'success') {
          this.taxBaseAmount = response.data.tax;
        }
      }
      catch (error) {
        console.log(error);
      }
    },
    calcOrderVatTotal: function () {
      let orderVatAmount = 0;
      if (this.orderItems.length > 0) {
        let tax = this.taxBaseAmount;
        this.orderItems.forEach(function (order) {
          if(order.tax == 'Standard' || order.tax != 1){
            let newStandardRate = order.standard_rate / tax;
            let newPrice = newStandardRate * order.qty;
            let vatAmount = -1*order.qty <1 ? -1*(parseInt(order.price) + newPrice):parseInt(order.price) - newPrice;
            orderVatAmount += Math.round(vatAmount)
          }
        });
      }
      if (this.currentItem.length > 0) {
        let tax = this.taxBaseAmount;
        this.currentItem.forEach(function (order) {
          if(order.tax == 'Standard' || order.tax != 1){
            let newStandardRate = order.standard_rate / tax;
            let newPrice = newStandardRate * order.qty;
            let vatAmount = order.price - newPrice;
            orderVatAmount += Math.round(vatAmount)
          }
        });
      }
      return orderVatAmount;
    },

    calcPrecision: function(amount){
        let prcision = 0;
        let amountDiff = 0;
        let diff = parseFloat(amount).toFixed(2) - Math.round((parseFloat(amount).toFixed(2)));
        diff = Math.round(diff*100)/100;
        if(diff < 0){
          diff = 1 + diff;
        }
        if(diff > 0){
          if(diff >= 0 && diff <= 0.12){
              prcision = 0
              amountDiff = 0 - diff;          }
          if(diff > 0.12 && diff <= 0.37){
              prcision = 0.25
              amountDiff =  0.25 - diff;
          }
          if(diff > 0.37 && diff <= 0.62){
              prcision = 0.50;
              amountDiff = 0.5 - diff;
          }

          if(diff > 0.62 && diff <= 0.87){
              prcision = 0.75;
              amountDiff = 0.75 - diff;
          }
          if(diff > 0.87 && diff <= 1){
              prcision = 1;
              amountDiff = 1 - diff;
          }
        amountDiff = Math.round(amountDiff*1000)/1000;
        }
        prcision = parseFloat(((Math.round(prcision*1000))/1000)).toFixed(2);
        return amountDiff;
    },        

    calcAmountPrecision: function(amount){
      this.calcPrecision(amount)     
    return amount + this.calcPrecision(amount) ;
    },        
  
    calcOrderTotalAmount_old: function(){
        let orderAmount = 0;
        if(this.orderItems.length>0){
          this.orderItems.forEach(function(order) {
          orderAmount = orderAmount + parseFloat(order.price);
          });        
        }
        if(this.currentItem.length>0){
          this.currentItem.forEach(function(order) {
          orderAmount = orderAmount + parseFloat(order.price);
          });
        }

        this.netTotalAmount = this.calcOrderNetTotal();
        //this.discountAmount = this.calcOrderDiscount();
        this.vatAmount = (this.netTotalAmount - (this.discountAmount)/1.05) *0.05;
        this.grandTotalAmount = this.calcAmountPrecision((this.netTotalAmount-(this.discountAmount)/1.05)+this.vatAmount);
        this.diffAmount = this.calcPrecision((this.netTotalAmount-(this.discountAmount)/1.05)+this.vatAmount);
        
        this.notPaidAmount = (parseFloat(this.grandTotalAmount).toFixed(2)) -(parseFloat(this.paidAmount).toFixed(2)) ;// - this.creditAmount - this.balance - this.accountAmount;

        this.outstandingAmount = parseFloat(this.notPaidAmount).toFixed(2);
        
       
    },

    calcOrderNetTotal_old: function(){
        let orderAmount = 0;
        if(this.orderItems.length>0){
          this.orderItems.forEach(function(order) {
          orderAmount = orderAmount + parseFloat(order.price);
          });        
        }
        if(this.currentItem.length>0){
          this.currentItem.forEach(function(order) {
          orderAmount = orderAmount + parseFloat(order.price);
          });
        }
        return orderAmount;
    },

    calcOrderDiscount: function(){
      let dis = 0;
      if(this.discountAmount !== 0){
        dis = this.discountAmount;
      }else{
        let promoDis = 0;
        if(this.prompMinimum_total <= this.netTotalAmount){
          if(this.orderItems.length>0){
            this.orderItems.forEach(function(order) {
              if(order.item_discount !=null && order.item_discount!== undefined){
                promoDis = promoDis + parseFloat(order.item_discount)*order.price/100;
              }
            });        
          }
          
          if(this.currentItem.length>0){
            this.currentItem.forEach(function(order) {
              if(order.item_discount !=null && order.item_discount!== undefined){
                promoDis = promoDis + parseFloat(order.item_discount)*order.price/100;
              }
            });
          }
        }
        dis = promoDis;
        let persDis = 0;
        if(this.dis_percentage>0){
          persDis = this.netTotalAmount*(this.dis_percentage/100);
        }

        if(persDis > promoDis){
          dis = persDis;
        }

      }
        return dis;
    },

    calcPrecision_old: function(amount){
        let prcision = 0;
        let diff = parseFloat(amount).toFixed(2) - Math.round((parseFloat(amount).toFixed(2)));
        if(diff < 0){
          diff = diff+1;
        }
        if(diff > 0){
          if(diff > 0 && diff < 0.25){
              prcision = diff
          }
          if(diff > 0.25 && diff < 0.5){
              prcision = 0.50 - diff;
          }

          if(diff > 0.5 && diff < 0.75){
              prcision = 0.75 - diff ;
          }
          if(diff > 0.75 && diff < 1){
              prcision = 1 - diff ;
          }

        }
        prcision = parseFloat(((Math.round(prcision*1000))/1000)).toFixed(2);
        return prcision;
    },        

    calcAmountPrecision_old: function(amount){
      let calulatedAmount = amount;
        let prcision = amount;
        let diff = parseFloat(amount).toFixed(2) - Math.round((parseFloat(amount).toFixed(2)));
        if(diff < 0){
          diff = diff+1;
        }
        if(diff > 0){
          if(diff > 0 && diff < 0.25){
              calulatedAmount = Math.round(parseFloat(amount).toFixed(2));
              prcision = diff
          }
          if(diff > 0.25 && diff < 0.5){
              calulatedAmount = Math.round(parseFloat(amount).toFixed(2))+0.5;
              prcision = 0.50 - diff;
          }

          if(diff > 0.5 && diff < 0.75){
              calulatedAmount = Math.round(parseFloat(amount).toFixed(2))-0.25;
              prcision = 0.75 - diff ;
          }
          if(diff > 0.75 && diff < 1){
              calulatedAmount = Math.round(parseFloat(amount).toFixed(2));
              prcision = 1 - diff ;
          }

        }
        return calulatedAmount;
    },        

    addProductToOrder: function(product){
      this.changeAmount = 0;
      this.showChange = false;
      if(this.currentItem.length===0){

      }else{
          let tempOrderItems = [];
          tempOrderItems = this.orderItems.filter(function(a){
            if(product.barcode !== null){
              if(a.barcode.toLowerCase()===product.barcode){
                  return true;
              }
            }
          return false;
          });                
          if(tempOrderItems.length >0){
              for( var i = 0; i < this.orderItems.length; i++){ 
                  if ( this.orderItems[i].barcode === product.barcode) { 
                    let newItem = this.orderItems[i];
                    if(this.orderType = "")
                    newItem.qty = this.orderItems[i].qty+1;
                    newItem.price = newItem.qty * this.orderItems[i].standard_rate;
                    this.orderItems.splice(i, 1);
                    this.orderItems.push(this.currentItem[0]);
                    this.currentItem = [];
                    this.currentItem.push(newItem);
                  }
              }  
              this.calcOrderTotalAmount();
          }else{
            if(product.barcode === this.currentItem[0].barcode){
              this.currentItem[0].qty = this.currentItem[0].qty + 1;
              this.currentItem[0].price = this.currentItem[0].standard_rate * this.currentItem[0].qty;
              this.calcOrderTotalAmount();

            }else{
              this.seqId = this.seqId+1;
              //this.orderItems[this.seqId] = this.currentItem[0];
              this.orderItems.push(this.currentItem[0]);
              this.orderItems.reverse();
              this.orderItems.reverse();
              this.currentItem = [];
              this.currentItem.push({
                "seqId":this.seqId, 
                "item_code":product.item_code,
                "item_name":product.item_name, 
                "item_group":product.item_group, 
                "barcode":product.barcode, 
                "standard_rate":parseFloat(product.standard_rate).toFixed(2),
                "price":parseFloat(product.standard_rate).toFixed(2),
                //"standard_rate_vat":parseFloat(product.standard_rate*1.05).toFixed(2),
                //"price_vat":parseFloat(product.standard_rate*1.05).toFixed(2),
                "qty":1,
                "item_discount":product.item_discount
                });
              this.calcOrderTotalAmount();
            }
          }
      }
      this.currentOrderDirty = true;
    },        
  },


    created: async function(barcodeVar){
       //document.getElementById("Barcode") ;
        //try{

            //Gift Card API
            //let dataURL = this.apiURL+'GiftCard/checkGiftCard';
            //let response = await axios.post(dataURL, {"appId": localStorage.appId, "giftcardnumber": "1234"}); 
            //console.log(response.data);
            
            //Void API
            //let dataURL = this.apiURL+'Users/checkForVoidPermision';
            //let response = await axios.post(dataURL, {"appId": localStorage.appId, "username":"viamenu", "password":"Demo1232"}); 
            //console.log(response.data);

            //Loyality API
            //let dataURL = this.apiURL+'Loyalty/checkLoyalty';
            //let response = await axios.post(dataURL, {"appId": localStorage.appId, "cardnumber": "919842285519"}); 
            //console.log(response.data);

            //Login With Last InvoiceId API
            //let dataURL = this.apiURL+'Login';
            //let response = await axios.post(dataURL, {"action": "login", "username": "viamenu", "password" : "Demo123"}); 
            //console.log(response.data);



            //let iniProducts = response.data.results.products;

            //for( var i = 0; i < iniProducts.length; i++){ 
            //  let ind = parseInt(iniProducts[i].barcode);
            //  this.products[ind] = iniProducts[i];
            //}


            //this.products[10001] = {"item_name":"Milk","arabic_item_name":null,"item_group":"Milk","barcode":"10001","standard_rate":"1.5","item_code":"000123"};
            //this.products[10002] ={"item_name":"Soap","arabic_item_name":null,"item_group":"Soap","barcode":"10002","standard_rate":"2.5","item_code":"000124"};

//console.log("this.lastinvoicenumber", this.lastinvoicenumber);
            ///this.products = [
            //  {"a10001":{"item_name":"Milk","arabic_item_name":null,"item_group":"Milk","barcode":"10001","standard_rate":"1.5","item_code":"000123"},"a10002":{"item_name":"Soap","arabic_item_name":null,"item_group":"Soap","barcode":"10002","standard_rate":"2.5","item_code":"000124"}}
            //  ];
            /*
            this.products = [
              {"item_name":"Milk","arabic_item_name":null,"item_group":"Milk","barcode":"10001","standard_rate":"1.5","item_code":"000123"},
              {"item_name":"Soap","arabic_item_name":null,"item_group":"Soap","barcode":"10002","standard_rate":"2.5","item_code":"000124"},
               {"item_name":"juice1","arabic_item_name":null,"item_group":"juice","barcode":"10003","standard_rate":"3","item_code":"0003"},
               {"item_name":"juice2","arabic_item_name":null,"item_group":"juice","barcode":"10004","standard_rate":"4","item_code":"0004"},
               {"item_name":"juice3","arabic_item_name":null,"item_group":"juice","barcode":"10005","standard_rate":"5","item_code":"0005"},
               {"item_name":"juice4","arabic_item_name":null,"item_group":"juice","barcode":"10006","standard_rate":"6","item_code":"0006"},
               {"item_name":"juice5","arabic_item_name":null,"item_group":"juice","barcode":"10007","standard_rate":"7","item_code":"0007"},
               {"item_name":"juice6","arabic_item_name":null,"item_group":"juice","barcode":"10008","standard_rate":"8","item_code":"0008"},
               {"item_name":"juice7","arabic_item_name":null,"item_group":"juice","barcode":"10009","standard_rate":"9","item_code":"0009"},
               {"item_name":"juice8","arabic_item_name":null,"item_group":"juice","barcode":"10010","standard_rate":"10","item_code":"00010"},
               {"item_name":"juice9","arabic_item_name":null,"item_group":"juice","barcode":"10011","standard_rate":"11","item_code":"00011"},
               {"item_name":"Tomato","arabic_item_name":null,"item_group":"Tomato","barcode":"00001","standard_rate":"1.5","item_code":"000123"},
               {"item_name":"Carrot","arabic_item_name":null,"item_group":"Carrot","barcode":"00002","standard_rate":"2.5","item_code":"000124"}, 
               {"item_name":"Mushroom","arabic_item_name":null,"item_group":"Mushroom","barcode":"00003","standard_rate":"3","item_code":"000125"},
               {"item_name":"Carrot","arabic_item_name":null,"item_group":"Carrot","barcode":"00004","standard_rate":"2.5","item_code":"000124"}, 
               {"item_name":"Mushroom","arabic_item_name":null,"item_group":"Mushroom","barcode":"00005","standard_rate":"3","item_code":"000125"},
               {"item_name":"Green Apple","arabic_item_name":null,"item_group":"Apple","barcode":"11111","standard_rate":"8","item_code":"0001111"}
               ];
              */
        //}
        //catch (error){
        //    console.log(error);
        //}
        this.lastinvoicenumber = localStorage.lastinvoicenumber;
    },
    setup(){
    //const route = useRoute();
    //const lastinvoicenumber = ref(route.params)
     //console.log( "route.lastinvoicenumber", route.params.lastinvoicenumber );
       //const invNum = route.params.lastinvoicenumber;
     //console.log( "route.lastinvoicenumber", invNum );
       
      const isOpen = ref(false);
      const isPaymentOpen = ref(false);
      const isLoyalityOpen = ref(false);
      const isGiftCardOpen = ref(false);      
      const isVoidOpen = ref(false);
      const isReasonOpen = ref(false);
      const isCheckPriceOpen = ref(false);
      const isNewProductOpen = ref(false);
      //const isKeyboardOpen = ref(false);     
       
      const isKeypadOpen = ref(false);
      const isPayCashOpen = ref(false);
      const isPayCreditOpen = ref(false);
      const isPayAccountOpen = ref(false);
      const isCloseCashOpen = ref(false);
      const isShowInfosOpen = ref(false);
      
      const totalPaymentAmount = ref(Number);
      
      let orderItems = ref(Array);
      const orderId = ref(String);
      const customernumber = ref(String);
      
      return { isOpen, isPaymentOpen, totalPaymentAmount, isLoyalityOpen, isGiftCardOpen, isReasonOpen, isVoidOpen, isKeypadOpen, isCheckPriceOpen, isPayCashOpen, isPayCreditOpen, isPayAccountOpen, isCloseCashOpen, isShowInfosOpen, isNewProductOpen }
    }
 }
</script>
<style>

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
    font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #EEEEEE;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #CCCCCC;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #CCCCCC; */
}
.grid-container-element { 
    display: grid; 
    grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr; 
    grid-gap: 10px; 
    border: 1px solid whitesmoke; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    width: 100%; 
} 
.grid-child-element_ { 
    margin: 10px; 
    border: 1px solid red; 
}
.grid-child-element { 
    margin: 2px; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    padding : 0 px;
    
}
.swal2-title{
    font-family: monospace !important;
    color:red;
}
.numberCircleGreen {
    border-radius: 50%;
    width: 36px;
    height: 36px;
    padding: 8px;

    background: green;
    border: 2px solid #666;
    color: #666;
    text-align: center;

    font: 32px Arial, sans-serif;
}
.numberCircleRed {
    border-radius: 50%;
    width: 36px;
    height: 36px;
    padding: 8px;

    background: red;
    border: 2px solid #666;
    color: #666;
    text-align: center;

    font: 32px Arial, sans-serif;
}
.circle {
  border: 0.1em solid grey;
  border-radius: 100%;
  height: 1.5em;
  width: 1.5em;
  text-align: center;
  background: red;
}

.circle p {
  margin-top: 0.10em;
  font-size: 1em;
  font-weight: bold;
  font-family: sans-serif;
  color: grey;
  background: red;
}
.orders-container{
  width: 100%;
}

.order-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: #fff;
  font-size: 18px;
  padding: 12px 10px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.order-row span{
  flex: 1;
}

.order-id{
  background: rgba(255,255,255,0.1);
  padding: 6px 14px;
  margin-right: 5px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.2);
  flex: 1.5;
}
</style>